import { Conjugation } from '../types';

export const conjugations: Conjugation[] = [
  // être - present
  {
    verbInfinitive: 'être',
    tense: 'present',
    je: 'suis',
    tu: 'es',
    il: 'est',
    nous: 'sommes',
    vous: 'êtes',
    ils: 'sont'
  },
  // être - imparfait
  {
    verbInfinitive: 'être',
    tense: 'imparfait',
    je: 'étais',
    tu: 'étais',
    il: 'était',
    nous: 'étions',
    vous: 'étiez',
    ils: 'étaient'
  },
  // être - futur simple
  {
    verbInfinitive: 'être',
    tense: 'futur_simple',
    je: 'serai',
    tu: 'seras',
    il: 'sera',
    nous: 'serons',
    vous: 'serez',
    ils: 'seront'
  },
  // être - passé composé
  {
    verbInfinitive: 'être',
    tense: 'passe_compose',
    je: 'ai été',
    tu: 'as été',
    il: 'a été',
    nous: 'avons été',
    vous: 'avez été',
    ils: 'ont été'
  },
  // être - conditionnel présent
  {
    verbInfinitive: 'être',
    tense: 'conditionnel_present',
    je: 'serais',
    tu: 'serais',
    il: 'serait',
    nous: 'serions',
    vous: 'seriez',
    ils: 'seraient'
  },
  // être - subjonctif présent
  {
    verbInfinitive: 'être',
    tense: 'subjonctif_present',
    je: 'sois',
    tu: 'sois',
    il: 'soit',
    nous: 'soyons',
    vous: 'soyez',
    ils: 'soient'
  },

  // avoir - present
  {
    verbInfinitive: 'avoir',
    tense: 'present',
    je: 'ai',
    tu: 'as',
    il: 'a',
    nous: 'avons',
    vous: 'avez',
    ils: 'ont'
  },
  // avoir - imparfait
  {
    verbInfinitive: 'avoir',
    tense: 'imparfait',
    je: 'avais',
    tu: 'avais',
    il: 'avait',
    nous: 'avions',
    vous: 'aviez',
    ils: 'avaient'
  },
  // avoir - futur simple
  {
    verbInfinitive: 'avoir',
    tense: 'futur_simple',
    je: 'aurai',
    tu: 'auras',
    il: 'aura',
    nous: 'aurons',
    vous: 'aurez',
    ils: 'auront'
  },
  // avoir - passé composé
  {
    verbInfinitive: 'avoir',
    tense: 'passe_compose',
    je: 'ai eu',
    tu: 'as eu',
    il: 'a eu',
    nous: 'avons eu',
    vous: 'avez eu',
    ils: 'ont eu'
  },
  // avoir - conditionnel présent
  {
    verbInfinitive: 'avoir',
    tense: 'conditionnel_present',
    je: 'aurais',
    tu: 'aurais',
    il: 'aurait',
    nous: 'aurions',
    vous: 'auriez',
    ils: 'auraient'
  },
  // avoir - subjonctif présent
  {
    verbInfinitive: 'avoir',
    tense: 'subjonctif_present',
    je: 'aie',
    tu: 'aies',
    il: 'ait',
    nous: 'ayons',
    vous: 'ayez',
    ils: 'aient'
  },

  // aller - present
  {
    verbInfinitive: 'aller',
    tense: 'present',
    je: 'vais',
    tu: 'vas',
    il: 'va',
    nous: 'allons',
    vous: 'allez',
    ils: 'vont'
  },
  // aller - imparfait
  {
    verbInfinitive: 'aller',
    tense: 'imparfait',
    je: 'allais',
    tu: 'allais',
    il: 'allait',
    nous: 'allions',
    vous: 'alliez',
    ils: 'allaient'
  },
  // aller - futur simple
  {
    verbInfinitive: 'aller',
    tense: 'futur_simple',
    je: 'irai',
    tu: 'iras',
    il: 'ira',
    nous: 'irons',
    vous: 'irez',
    ils: 'iront'
  },
  // aller - passé composé
  {
    verbInfinitive: 'aller',
    tense: 'passe_compose',
    je: 'suis allé',
    tu: 'es allé',
    il: 'est allé',
    nous: 'sommes allés',
    vous: 'êtes allés',
    ils: 'sont allés'
  },
  // aller - conditionnel présent
  {
    verbInfinitive: 'aller',
    tense: 'conditionnel_present',
    je: 'irais',
    tu: 'irais',
    il: 'irait',
    nous: 'irions',
    vous: 'iriez',
    ils: 'iraient'
  },
  // aller - subjonctif présent
  {
    verbInfinitive: 'aller',
    tense: 'subjonctif_present',
    je: 'aille',
    tu: 'ailles',
    il: 'aille',
    nous: 'allions',
    vous: 'alliez',
    ils: 'aillent'
  },

  // faire - present
  {
    verbInfinitive: 'faire',
    tense: 'present',
    je: 'fais',
    tu: 'fais',
    il: 'fait',
    nous: 'faisons',
    vous: 'faites',
    ils: 'font'
  },
  // faire - imparfait
  {
    verbInfinitive: 'faire',
    tense: 'imparfait',
    je: 'faisais',
    tu: 'faisais',
    il: 'faisait',
    nous: 'faisions',
    vous: 'faisiez',
    ils: 'faisaient'
  },
  // faire - futur simple
  {
    verbInfinitive: 'faire',
    tense: 'futur_simple',
    je: 'ferai',
    tu: 'feras',
    il: 'fera',
    nous: 'ferons',
    vous: 'ferez',
    ils: 'feront'
  },
  // faire - passé composé
  {
    verbInfinitive: 'faire',
    tense: 'passe_compose',
    je: 'ai fait',
    tu: 'as fait',
    il: 'a fait',
    nous: 'avons fait',
    vous: 'avez fait',
    ils: 'ont fait'
  },
  // faire - conditionnel présent
  {
    verbInfinitive: 'faire',
    tense: 'conditionnel_present',
    je: 'ferais',
    tu: 'ferais',
    il: 'ferait',
    nous: 'ferions',
    vous: 'feriez',
    ils: 'feraient'
  },
  // faire - subjonctif présent
  {
    verbInfinitive: 'faire',
    tense: 'subjonctif_present',
    je: 'fasse',
    tu: 'fasses',
    il: 'fasse',
    nous: 'fassions',
    vous: 'fassiez',
    ils: 'fassent'
  },

  // parler - present
  {
    verbInfinitive: 'parler',
    tense: 'present',
    je: 'parle',
    tu: 'parles',
    il: 'parle',
    nous: 'parlons',
    vous: 'parlez',
    ils: 'parlent'
  },
  // parler - imparfait
  {
    verbInfinitive: 'parler',
    tense: 'imparfait',
    je: 'parlais',
    tu: 'parlais',
    il: 'parlait',
    nous: 'parlions',
    vous: 'parliez',
    ils: 'parlaient'
  },
  // parler - futur simple
  {
    verbInfinitive: 'parler',
    tense: 'futur_simple',
    je: 'parlerai',
    tu: 'parleras',
    il: 'parlera',
    nous: 'parlerons',
    vous: 'parlerez',
    ils: 'parleront'
  },
  // parler - passé composé
  {
    verbInfinitive: 'parler',
    tense: 'passe_compose',
    je: 'ai parlé',
    tu: 'as parlé',
    il: 'a parlé',
    nous: 'avons parlé',
    vous: 'avez parlé',
    ils: 'ont parlé'
  },
  // parler - conditionnel présent
  {
    verbInfinitive: 'parler',
    tense: 'conditionnel_present',
    je: 'parlerais',
    tu: 'parlerais',
    il: 'parlerait',
    nous: 'parlerions',
    vous: 'parleriez',
    ils: 'parleraient'
  },
  // parler - subjonctif présent
  {
    verbInfinitive: 'parler',
    tense: 'subjonctif_present',
    je: 'parle',
    tu: 'parles',
    il: 'parle',
    nous: 'parlions',
    vous: 'parliez',
    ils: 'parlent'
  },

  // finir - present
  {
    verbInfinitive: 'finir',
    tense: 'present',
    je: 'finis',
    tu: 'finis',
    il: 'finit',
    nous: 'finissons',
    vous: 'finissez',
    ils: 'finissent'
  },
  // finir - imparfait
  {
    verbInfinitive: 'finir',
    tense: 'imparfait',
    je: 'finissais',
    tu: 'finissais',
    il: 'finissait',
    nous: 'finissions',
    vous: 'finissiez',
    ils: 'finissaient'
  },
  // finir - futur simple
  {
    verbInfinitive: 'finir',
    tense: 'futur_simple',
    je: 'finirai',
    tu: 'finiras',
    il: 'finira',
    nous: 'finirons',
    vous: 'finirez',
    ils: 'finiront'
  },
  // finir - passé composé
  {
    verbInfinitive: 'finir',
    tense: 'passe_compose',
    je: 'ai fini',
    tu: 'as fini',
    il: 'a fini',
    nous: 'avons fini',
    vous: 'avez fini',
    ils: 'ont fini'
  },
  // finir - conditionnel présent
  {
    verbInfinitive: 'finir',
    tense: 'conditionnel_present',
    je: 'finirais',
    tu: 'finirais',
    il: 'finirait',
    nous: 'finirions',
    vous: 'finiriez',
    ils: 'finiraient'
  },
  // finir - subjonctif présent
  {
    verbInfinitive: 'finir',
    tense: 'subjonctif_present',
    je: 'finisse',
    tu: 'finisses',
    il: 'finisse',
    nous: 'finissions',
    vous: 'finissiez',
    ils: 'finissent'
  },
  // vouloir - present
  {
    verbInfinitive: 'vouloir',
    tense: 'present',
    je: 'veux',
    tu: 'veux',
    il: 'veut',
    nous: 'voulons',
    vous: 'voulez',
    ils: 'veulent'
  },
  // vouloir - imparfait
  {
    verbInfinitive: 'vouloir',
    tense: 'imparfait',
    je: 'voulais',
    tu: 'voulais',
    il: 'voulait',
    nous: 'voulions',
    vous: 'vouliez',
    ils: 'voulaient'
  },
  // vouloir - futur simple
  {
    verbInfinitive: 'vouloir',
    tense: 'futur_simple',
    je: 'voudrai',
    tu: 'voudras',
    il: 'voudra',
    nous: 'voudrons',
    vous: 'voudrez',
    ils: 'voudront'
  },

  // prendre - present
  {
    verbInfinitive: 'prendre',
    tense: 'present',
    je: 'prends',
    tu: 'prends',
    il: 'prend',
    nous: 'prenons',
    vous: 'prenez',
    ils: 'prennent'
  },
  // prendre - imparfait
  {
    verbInfinitive: 'prendre',
    tense: 'imparfait',
    je: 'prenais',
    tu: 'prenais',
    il: 'prenait',
    nous: 'prenions',
    vous: 'preniez',
    ils: 'prenaient'
  },
  // prendre - futur simple
  {
    verbInfinitive: 'prendre',
    tense: 'futur_simple',
    je: 'prendrai',
    tu: 'prendras',
    il: 'prendra',
    nous: 'prendrons',
    vous: 'prendrez',
    ils: 'prendront'
  },

  // mettre - present
  {
    verbInfinitive: 'mettre',
    tense: 'present',
    je: 'mets',
    tu: 'mets',
    il: 'met',
    nous: 'mettons',
    vous: 'mettez',
    ils: 'mettent'
  },
  // mettre - imparfait
  {
    verbInfinitive: 'mettre',
    tense: 'imparfait',
    je: 'mettais',
    tu: 'mettais',
    il: 'mettait',
    nous: 'mettions',
    vous: 'mettiez',
    ils: 'mettaient'
  },
  // mettre - futur simple
  {
    verbInfinitive: 'mettre',
    tense: 'futur_simple',
    je: 'mettrai',
    tu: 'mettras',
    il: 'mettra',
    nous: 'mettrons',
    vous: 'mettrez',
    ils: 'mettront'
  },

  // comprendre - present
  {
    verbInfinitive: 'comprendre',
    tense: 'present',
    je: 'comprends',
    tu: 'comprends',
    il: 'comprend',
    nous: 'comprenons',
    vous: 'comprenez',
    ils: 'comprennent'
  },
  // comprendre - imparfait
  {
    verbInfinitive: 'comprendre',
    tense: 'imparfait',
    je: 'comprenais',
    tu: 'comprenais',
    il: 'comprenait',
    nous: 'comprenions',
    vous: 'compreniez',
    ils: 'comprenaient'
  },
  // comprendre - futur simple
  {
    verbInfinitive: 'comprendre',
    tense: 'futur_simple',
    je: 'comprendrai',
    tu: 'comprendras',
    il: 'comprendra',
    nous: 'comprendrons',
    vous: 'comprendrez',
    ils: 'comprendront'
  },

  // écrire - present
  {
    verbInfinitive: 'écrire',
    tense: 'present',
    je: 'écris',
    tu: 'écris',
    il: 'écrit',
    nous: 'écrivons',
    vous: 'écrivez',
    ils: 'écrivent'
  },
  // écrire - imparfait
  {
    verbInfinitive: 'écrire',
    tense: 'imparfait',
    je: 'écrivais',
    tu: 'écrivais',
    il: 'écrivait',
    nous: 'écrivions',
    vous: 'écriviez',
    ils: 'écrivaient'
  },
  // écrire - futur simple
  {
    verbInfinitive: 'écrire',
    tense: 'futur_simple',
    je: 'écrirai',
    tu: 'écriras',
    il: 'écrira',
    nous: 'écrirons',
    vous: 'écrirez',
    ils: 'écriront'
  },

  // lire - present
  {
    verbInfinitive: 'lire',
    tense: 'present',
    je: 'lis',
    tu: 'lis',
    il: 'lit',
    nous: 'lisons',
    vous: 'lisez',
    ils: 'lisent'
  },
  // lire - imparfait
  {
    verbInfinitive: 'lire',
    tense: 'imparfait',
    je: 'lisais',
    tu: 'lisais',
    il: 'lisait',
    nous: 'lisions',
    vous: 'lisiez',
    ils: 'lisaient'
  },
  // lire - futur simple
  {
    verbInfinitive: 'lire',
    tense: 'futur_simple',
    je: 'lirai',
    tu: 'liras',
    il: 'lira',
    nous: 'lirons',
    vous: 'lirez',
    ils: 'liront'
  },

  // jouer - present
  {
    verbInfinitive: 'jouer',
    tense: 'present',
    je: 'joue',
    tu: 'joues',
    il: 'joue',
    nous: 'jouons',
    vous: 'jouez',
    ils: 'jouent'
  },
  // jouer - imparfait
  {
    verbInfinitive: 'jouer',
    tense: 'imparfait',
    je: 'jouais',
    tu: 'jouais',
    il: 'jouait',
    nous: 'jouions',
    vous: 'jouiez',
    ils: 'jouaient'
  },
  // jouer - futur simple
  {
    verbInfinitive: 'jouer',
    tense: 'futur_simple',
    je: 'jouerai',
    tu: 'joueras',
    il: 'jouera',
    nous: 'jouerons',
    vous: 'jouerez',
    ils: 'joueront'
  },

  // regarder - present
  {
    verbInfinitive: 'regarder',
    tense: 'present',
    je: 'regarde',
    tu: 'regardes',
    il: 'regarde',
    nous: 'regardons',
    vous: 'regardez',
    ils: 'regardent'
  },
  // regarder - imparfait
  {
    verbInfinitive: 'regarder',
    tense: 'imparfait',
    je: 'regardais',
    tu: 'regardais',
    il: 'regardait',
    nous: 'regardions',
    vous: 'regardiez',
    ils: 'regardaient'
  },
  // regarder - futur simple
  {
    verbInfinitive: 'regarder',
    tense: 'futur_simple',
    je: 'regarderai',
    tu: 'regarderas',
    il: 'regardera',
    nous: 'regarderons',
    vous: 'regarderez',
    ils: 'regarderont'
  },

  // écouter - present
  {
    verbInfinitive: 'écouter',
    tense: 'present',
    je: 'écoute',
    tu: 'écoutes',
    il: 'écoute',
    nous: 'écoutons',
    vous: 'écoutez',
    ils: 'écoutent'
  },
  // écouter - imparfait
  {
    verbInfinitive: 'écouter',
    tense: 'imparfait',
    je: 'écoutais',
    tu: 'écoutais',
    il: 'écoutait',
    nous: 'écoutions',
    vous: 'écoutiez',
    ils: 'écoutaient'
  },
  // écouter - futur simple
  {
    verbInfinitive: 'écouter',
    tense: 'futur_simple',
    je: 'écouterai',
    tu: 'écouteras',
    il: 'écoutera',
    nous: 'écouterons',
    vous: 'écouterez',
    ils: 'écouteront'
  },

  // chanter - present
  {
    verbInfinitive: 'chanter',
    tense: 'present',
    je: 'chante',
    tu: 'chantes',
    il: 'chante',
    nous: 'chantons',
    vous: 'chantez',
    ils: 'chantent'
  },
  // chanter - imparfait
  {
    verbInfinitive: 'chanter',
    tense: 'imparfait',
    je: 'chantais',
    tu: 'chantais',
    il: 'chantait',
    nous: 'chantions',
    vous: 'chantiez',
    ils: 'chantaient'
  },
  // chanter - futur simple
  {
    verbInfinitive: 'chanter',
    tense: 'futur_simple',
    je: 'chanterai',
    tu: 'chanteras',
    il: 'chantera',
    nous: 'chanterons',
    vous: 'chanterez',
    ils: 'chanteront'
  },

  // agir - present
  {
    verbInfinitive: 'agir',
    tense: 'present',
    je: 'agis',
    tu: 'agis',
    il: 'agit',
    nous: 'agissons',
    vous: 'agissez',
    ils: 'agissent'
  },
  // agir - imparfait
  {
    verbInfinitive: 'agir',
    tense: 'imparfait',
    je: 'agissais',
    tu: 'agissais',
    il: 'agissait',
    nous: 'agissions',
    vous: 'agissiez',
    ils: 'agissaient'
  },
  // agir - futur simple
  {
    verbInfinitive: 'agir',
    tense: 'futur_simple',
    je: 'agirai',
    tu: 'agiras',
    il: 'agira',
    nous: 'agirons',
    vous: 'agirez',
    ils: 'agiront'
  },

  // sortir - present
  {
    verbInfinitive: 'sortir',
    tense: 'present',
    je: 'sors',
    tu: 'sors',
    il: 'sort',
    nous: 'sortons',
    vous: 'sortez',
    ils: 'sortent'
  },
  // sortir - imparfait
  {
    verbInfinitive: 'sortir',
    tense: 'imparfait',
    je: 'sortais',
    tu: 'sortais',
    il: 'sortait',
    nous: 'sortions',
    vous: 'sortiez',
    ils: 'sortaient'
  },
  // sortir - futur simple
  {
    verbInfinitive: 'sortir',
    tense: 'futur_simple',
    je: 'sortirai',
    tu: 'sortiras',
    il: 'sortira',
    nous: 'sortirons',
    vous: 'sortirez',
    ils: 'sortiront'
  },

  // partir - present
  {
    verbInfinitive: 'partir',
    tense: 'present',
    je: 'pars',
    tu: 'pars',
    il: 'part',
    nous: 'partons',
    vous: 'partez',
    ils: 'partent'
  },
  // partir - imparfait
  {
    verbInfinitive: 'partir',
    tense: 'imparfait',
    je: 'partais',
    tu: 'partais',
    il: 'partait',
    nous: 'partions',
    vous: 'partiez',
    ils: 'partaient'
  },
  // partir - futur simple
  {
    verbInfinitive: 'partir',
    tense: 'futur_simple',
    je: 'partirai',
    tu: 'partiras',
    il: 'partira',
    nous: 'partirons',
    vous: 'partirez',
    ils: 'partiront'
  },

  // dormir - present
  {
    verbInfinitive: 'dormir',
    tense: 'present',
    je: 'dors',
    tu: 'dors',
    il: 'dort',
    nous: 'dormons',
    vous: 'dormez',
    ils: 'dorment'
  },
  // dormir - imparfait
  {
    verbInfinitive: 'dormir',
    tense: 'imparfait',
    je: 'dormais',
    tu: 'dormais',
    il: 'dormait',
    nous: 'dormions',
    vous: 'dormiez',
    ils: 'dormaient'
  },
  // dormir - futur simple
  {
    verbInfinitive: 'dormir',
    tense: 'futur_simple',
    je: 'dormirai',
    tu: 'dormiras',
    il: 'dormira',
    nous: 'dormirons',
    vous: 'dormirez',
    ils: 'dormiront'
  },

  // ouvrir - present
  {
    verbInfinitive: 'ouvrir',
    tense: 'present',
    je: 'ouvre',
    tu: 'ouvres',
    il: 'ouvre',
    nous: 'ouvrons',
    vous: 'ouvrez',
    ils: 'ouvrent'
  },
  // ouvrir - imparfait
  {
    verbInfinitive: 'ouvrir',
    tense: 'imparfait',
    je: 'ouvrais',
    tu: 'ouvrais',
    il: 'ouvrait',
    nous: 'ouvrions',
    vous: 'ouvriez',
    ils: 'ouvraient'
  },
  // ouvrir - futur simple
  {
    verbInfinitive: 'ouvrir',
    tense: 'futur_simple',
    je: 'ouvrirai',
    tu: 'ouvriras',
    il: 'ouvrira',
    nous: 'ouvrirons',
    vous: 'ouvrirez',
    ils: 'ouvriront'
  },

  // offrir - present
  {
    verbInfinitive: 'offrir',
    tense: 'present',
    je: 'offre',
    tu: 'offres',
    il: 'offre',
    nous: 'offrons',
    vous: 'offrez',
    ils: 'offrent'
  },
  // offrir - imparfait
  {
    verbInfinitive: 'offrir',
    tense: 'imparfait',
    je: 'offrais',
    tu: 'offrais',
    il: 'offrait',
    nous: 'offrions',
    vous: 'offriez',
    ils: 'offraient'
  },
  // offrir - futur simple
  {
    verbInfinitive: 'offrir',
    tense: 'futur_simple',
    je: 'offrirai',
    tu: 'offriras',
    il: 'offrira',
    nous: 'offrirons',
    vous: 'offrirez',
    ils: 'offriront'
  },

  // marcher - present
  {
    verbInfinitive: 'marcher',
    tense: 'present',
    je: 'marche',
    tu: 'marches',
    il: 'marche',
    nous: 'marchons',
    vous: 'marchez',
    ils: 'marchent'
  },
  // marcher - imparfait
  {
    verbInfinitive: 'marcher',
    tense: 'imparfait',
    je: 'marchais',
    tu: 'marchais',
    il: 'marchait',
    nous: 'marchions',
    vous: 'marchiez',
    ils: 'marchaient'
  },
  // marcher - futur simple
  {
    verbInfinitive: 'marcher',
    tense: 'futur_simple',
    je: 'marcherai',
    tu: 'marcheras',
    il: 'marchera',
    nous: 'marcherons',
    vous: 'marcherez',
    ils: 'marcheront'
  },

  // chercher - present
  {
    verbInfinitive: 'chercher',
    tense: 'present',
    je: 'cherche',
    tu: 'cherches',
    il: 'cherche',
    nous: 'cherchons',
    vous: 'cherchez',
    ils: 'cherchent'
  },
  // chercher - imparfait
  {
    verbInfinitive: 'chercher',
    tense: 'imparfait',
    je: 'cherchais',
    tu: 'cherchais',
    il: 'cherchait',
    nous: 'cherchions',
    vous: 'cherchiez',
    ils: 'cherchaient'
  },
  // chercher - futur simple
  {
    verbInfinitive: 'chercher',
    tense: 'futur_simple',
    je: 'chercherai',
    tu: 'chercheras',
    il: 'cherchera',
    nous: 'chercherons',
    vous: 'chercherez',
    ils: 'chercheront'
  },

  // penser - present
  {
    verbInfinitive: 'penser',
    tense: 'present',
    je: 'pense',
    tu: 'penses',
    il: 'pense',
    nous: 'pensons',
    vous: 'pensez',
    ils: 'pensent'
  },
  // penser - imparfait
  {
    verbInfinitive: 'penser',
    tense: 'imparfait',
    je: 'pensais',
    tu: 'pensais',
    il: 'pensait',
    nous: 'pensions',
    vous: 'pensiez',
    ils: 'pensaient'
  },
  // penser - futur simple
  {
    verbInfinitive: 'penser',
    tense: 'futur_simple',
    je: 'penserai',
    tu: 'penseras',
    il: 'pensera',
    nous: 'penserons',
    vous: 'penserez',
    ils: 'penseront'
  },

  // demander - present
  {
    verbInfinitive: 'demander',
    tense: 'present',
    je: 'demande',
    tu: 'demandes',
    il: 'demande',
    nous: 'demandons',
    vous: 'demandez',
    ils: 'demandent'
  },
  // demander - imparfait
  {
    verbInfinitive: 'demander',
    tense: 'imparfait',
    je: 'demandais',
    tu: 'demandais',
    il: 'demandait',
    nous: 'demandions',
    vous: 'demandiez',
    ils: 'demandaient'
  },
  // demander - futur simple
  {
    verbInfinitive: 'demander',
    tense: 'futur_simple',
    je: 'demanderai',
    tu: 'demanderas',
    il: 'demandera',
    nous: 'demanderons',
    vous: 'demanderez',
    ils: 'demanderont'
  },

  // répondre - present
  {
    verbInfinitive: 'répondre',
    tense: 'present',
    je: 'réponds',
    tu: 'réponds',
    il: 'répond',
    nous: 'répondons',
    vous: 'répondez',
    ils: 'répondent'
  },
  // répondre - imparfait
  {
    verbInfinitive: 'répondre',
    tense: 'imparfait',
    je: 'répondais',
    tu: 'répondais',
    il: 'répondait',
    nous: 'répondions',
    vous: 'répondiez',
    ils: 'répondaient'
  },
  // répondre - futur simple
  {
    verbInfinitive: 'répondre',
    tense: 'futur_simple',
    je: 'répondrai',
    tu: 'répondras',
    il: 'répondra',
    nous: 'répondrons',
    vous: 'répondrez',
    ils: 'répondront'
  },

  // vendre - present
  {
    verbInfinitive: 'vendre',
    tense: 'present',
    je: 'vends',
    tu: 'vends',
    il: 'vend',
    nous: 'vendons',
    vous: 'vendez',
    ils: 'vendent'
  },
  // vendre - imparfait
  {
    verbInfinitive: 'vendre',
    tense: 'imparfait',
    je: 'vendais',
    tu: 'vendais',
    il: 'vendait',
    nous: 'vendions',
    vous: 'vendiez',
    ils: 'vendaient'
  },
  // vendre - futur simple
  {
    verbInfinitive: 'vendre',
    tense: 'futur_simple',
    je: 'vendrai',
    tu: 'vendras',
    il: 'vendra',
    nous: 'vendrons',
    vous: 'vendrez',
    ils: 'vendront'
  },

  // perdre - present
  {
    verbInfinitive: 'perdre',
    tense: 'present',
    je: 'perds',
    tu: 'perds',
    il: 'perd',
    nous: 'perdons',
    vous: 'perdez',
    ils: 'perdent'
  },
  // perdre - imparfait
  {
    verbInfinitive: 'perdre',
    tense: 'imparfait',
    je: 'perdais',
    tu: 'perdais',
    il: 'perdait',
    nous: 'perdions',
    vous: 'perdiez',
    ils: 'perdaient'
  },
  // perdre - futur simple
  {
    verbInfinitive: 'perdre',
    tense: 'futur_simple',
    je: 'perdrai',
    tu: 'perdras',
    il: 'perdra',
    nous: 'perdrons',
    vous: 'perdrez',
    ils: 'perdront'
  },

  // attendre - present
  {
    verbInfinitive: 'attendre',
    tense: 'present',
    je: 'attends',
    tu: 'attends',
    il: 'attend',
    nous: 'attendons',
    vous: 'attendez',
    ils: 'attendent'
  },
  // attendre - imparfait
  {
    verbInfinitive: 'attendre',
    tense: 'imparfait',
    je: 'attendais',
    tu: 'attendais',
    il: 'attendait',
    nous: 'attendions',
    vous: 'attendiez',
    ils: 'attendaient'
  },
  // attendre - futur simple
  {
    verbInfinitive: 'attendre',
    tense: 'futur_simple',
    je: 'attendrai',
    tu: 'attendras',
    il: 'attendra',
    nous: 'attendrons',
    vous: 'attendrez',
    ils: 'attendront'
  },

  // entendre - present
  {
    verbInfinitive: 'entendre',
    tense: 'present',
    je: 'entends',
    tu: 'entends',
    il: 'entend',
    nous: 'entendons',
    vous: 'entendez',
    ils: 'entendent'
  },
  // entendre - imparfait
  {
    verbInfinitive: 'entendre',
    tense: 'imparfait',
    je: 'entendais',
    tu: 'entendais',
    il: 'entendait',
    nous: 'entendions',
    vous: 'entendiez',
    ils: 'entendaient'
  },
  // entendre - futur simple
  {
    verbInfinitive: 'entendre',
    tense: 'futur_simple',
    je: 'entendrai',
    tu: 'entendras',
    il: 'entendra',
    nous: 'entendrons',
    vous: 'entendrez',
    ils: 'entendront'
  },

  // descendre - present
  {
    verbInfinitive: 'descendre',
    tense: 'present',
    je: 'descends',
    tu: 'descends',
    il: 'descend',
    nous: 'descendons',
    vous: 'descendez',
    ils: 'descendent'
  },
  // descendre - imparfait
  {
    verbInfinitive: 'descendre',
    tense: 'imparfait',
    je: 'descendais',
    tu: 'descendais',
    il: 'descendait',
    nous: 'descendions',
    vous: 'descendiez',
    ils: 'descendaient'
  },
  // descendre - futur simple
  {
    verbInfinitive: 'descendre',
    tense: 'futur_simple',
    je: 'descendrai',
    tu: 'descendras',
    il: 'descendra',
    nous: 'descendrons',
    vous: 'descendrez',
    ils: 'descendront'
  },

  // arriver - present
  {
    verbInfinitive: 'arriver',
    tense: 'present',
    je: 'arrive',
    tu: 'arrives',
    il: 'arrive',
    nous: 'arrivons',
    vous: 'arrivez',
    ils: 'arrivent'
  },
  // arriver - imparfait
  {
    verbInfinitive: 'arriver',
    tense: 'imparfait',
    je: 'arrivais',
    tu: 'arrivais',
    il: 'arrivait',
    nous: 'arrivions',
    vous: 'arriviez',
    ils: 'arrivaient'
  },
  // arriver - futur simple
  {
    verbInfinitive: 'arriver',
    tense: 'futur_simple',
    je: 'arriverai',
    tu: 'arriveras',
    il: 'arrivera',
    nous: 'arriverons',
    vous: 'arriverez',
    ils: 'arriveront'
  },

  // tomber - present
  {
    verbInfinitive: 'tomber',
    tense: 'present',
    je: 'tombe',
    tu: 'tombes',
    il: 'tombe',
    nous: 'tombons',
    vous: 'tombez',
    ils: 'tombent'
  },
  // tomber - imparfait
  {
    verbInfinitive: 'tomber',
    tense: 'imparfait',
    je: 'tombais',
    tu: 'tombais',
    il: 'tombait',
    nous: 'tombions',
    vous: 'tombiez',
    ils: 'tombaient'
  },
  // tomber - futur simple
  {
    verbInfinitive: 'tomber',
    tense: 'futur_simple',
    je: 'tomberai',
    tu: 'tomberas',
    il: 'tombera',
    nous: 'tomberons',
    vous: 'tomberez',
    ils: 'tomberont'
  },

  // monter - present
  {
    verbInfinitive: 'monter',
    tense: 'present',
    je: 'monte',
    tu: 'montes',
    il: 'monte',
    nous: 'montons',
    vous: 'montez',
    ils: 'montent'
  },
  // monter - imparfait
  {
    verbInfinitive: 'monter',
    tense: 'imparfait',
    je: 'montais',
    tu: 'montais',
    il: 'montait',
    nous: 'montions',
    vous: 'montiez',
    ils: 'montaient'
  },
  // monter - futur simple
  {
    verbInfinitive: 'monter',
    tense: 'futur_simple',
    je: 'monterai',
    tu: 'monteras',
    il: 'montera',
    nous: 'monterons',
    vous: 'monterez',
    ils: 'monteront'
  },

  // rester - present
  {
    verbInfinitive: 'rester',
    tense: 'present',
    je: 'reste',
    tu: 'restes',
    il: 'reste',
    nous: 'restons',
    vous: 'restez',
    ils: 'restent'
  },
  // rester - imparfait
  {
    verbInfinitive: 'rester',
    tense: 'imparfait',
    je: 'restais',
    tu: 'restais',
    il: 'restait',
    nous: 'restions',
    vous: 'restiez',
    ils: 'restaient'
  },
  // rester - futur simple
  {
    verbInfinitive: 'rester',
    tense: 'futur_simple',
    je: 'resterai',
    tu: 'resteras',
    il: 'restera',
    nous: 'resterons',
    vous: 'resterez',
    ils: 'resteront'
  },

  // sentir - present
  {
    verbInfinitive: 'sentir',
    tense: 'present',
    je: 'sens',
    tu: 'sens',
    il: 'sent',
    nous: 'sentons',
    vous: 'sentez',
    ils: 'sentent'
  },
  // sentir - imparfait
  {
    verbInfinitive: 'sentir',
    tense: 'imparfait',
    je: 'sentais',
    tu: 'sentais',
    il: 'sentait',
    nous: 'sentions',
    vous: 'sentiez',
    ils: 'sentaient'
  },
  // sentir - futur simple
  {
    verbInfinitive: 'sentir',
    tense: 'futur_simple',
    je: 'sentirai',
    tu: 'sentiras',
    il: 'sentira',
    nous: 'sentirons',
    vous: 'sentirez',
    ils: 'sentiront'
  },
  // Regular -er verbs (group 1) conjugations
  
  // se laver - present
  {
    verbInfinitive: 'se laver',
    tense: 'present',
    je: 'me lave',
    tu: 'te laves',
    il: 'se lave',
    nous: 'nous lavons',
    vous: 'vous lavez',
    ils: 'se lavent'
  },
  // se laver - imparfait
  {
    verbInfinitive: 'se laver',
    tense: 'imparfait',
    je: 'me lavais',
    tu: 'te lavais',
    il: 'se lavait',
    nous: 'nous lavions',
    vous: 'vous laviez',
    ils: 'se lavaient'
  },
  // se laver - futur simple
  {
    verbInfinitive: 'se laver',
    tense: 'futur_simple',
    je: 'me laverai',
    tu: 'te laveras',
    il: 'se lavera',
    nous: 'nous laverons',
    vous: 'vous laverez',
    ils: 'se laveront'
  },

  // se lever - present
  {
    verbInfinitive: 'se lever',
    tense: 'present',
    je: 'me lève',
    tu: 'te lèves',
    il: 'se lève',
    nous: 'nous levons',
    vous: 'vous levez',
    ils: 'se lèvent'
  },
  // se lever - imparfait
  {
    verbInfinitive: 'se lever',
    tense: 'imparfait',
    je: 'me levais',
    tu: 'te levais',
    il: 'se levait',
    nous: 'nous levions',
    vous: 'vous leviez',
    ils: 'se levaient'
  },
  // se lever - futur simple
  {
    verbInfinitive: 'se lever',
    tense: 'futur_simple',
    je: 'me lèverai',
    tu: 'te lèveras',
    il: 'se lèvera',
    nous: 'nous lèverons',
    vous: 'vous lèverez',
    ils: 'se lèveront'
  },

  // se coucher - present
  {
    verbInfinitive: 'se coucher',
    tense: 'present',
    je: 'me couche',
    tu: 'te couches',
    il: 'se couche',
    nous: 'nous couchons',
    vous: 'vous couchez',
    ils: 'se couchent'
  },
  // se coucher - imparfait
  {
    verbInfinitive: 'se coucher',
    tense: 'imparfait',
    je: 'me couchais',
    tu: 'te couchais',
    il: 'se couchait',
    nous: 'nous couchions',
    vous: 'vous couchiez',
    ils: 'se couchaient'
  },
  // se coucher - futur simple
  {
    verbInfinitive: 'se coucher',
    tense: 'futur_simple',
    je: 'me coucherai',
    tu: 'te coucheras',
    il: 'se couchera',
    nous: 'nous coucherons',
    vous: 'vous coucherez',
    ils: 'se coucheront'
  },

  // s'habiller - present
  {
    verbInfinitive: "s'habiller",
    tense: 'present',
    je: "m'habille",
    tu: "t'habilles",
    il: "s'habille",
    nous: 'nous habillons',
    vous: 'vous habillez',
    ils: "s'habillent"
  },
  // s'habiller - imparfait
  {
    verbInfinitive: "s'habiller",
    tense: 'imparfait',
    je: "m'habillais",
    tu: "t'habillais",
    il: "s'habillait",
    nous: 'nous habillions',
    vous: 'vous habilliez',
    ils: "s'habillaient"
  },
  // s'habiller - futur simple
  {
    verbInfinitive: "s'habiller",
    tense: 'futur_simple',
    je: "m'habillerai",
    tu: "t'habilleras",
    il: "s'habillera",
    nous: 'nous habillerons',
    vous: 'vous habillerez',
    ils: "s'habilleront"
  },

  // se réveiller - present
  {
    verbInfinitive: 'se réveiller',
    tense: 'present',
    je: 'me réveille',
    tu: 'te réveilles',
    il: 'se réveille',
    nous: 'nous réveillons',
    vous: 'vous réveillez',
    ils: 'se réveillent'
  },
  // se réveiller - imparfait
  {
    verbInfinitive: 'se réveiller',
    tense: 'imparfait',
    je: 'me réveillais',
    tu: 'te réveillais',
    il: 'se réveillait',
    nous: 'nous réveillions',
    vous: 'vous réveilliez',
    ils: 'se réveillaient'
  },
  // se réveiller - futur simple
  {
    verbInfinitive: 'se réveiller',
    tense: 'futur_simple',
    je: 'me réveillerai',
    tu: 'te réveilleras',
    il: 'se réveillera',
    nous: 'nous réveillerons',
    vous: 'vous réveillerez',
    ils: 'se réveilleront'
  },

  // nager - present
  {
    verbInfinitive: 'nager',
    tense: 'present',
    je: 'nage',
    tu: 'nages',
    il: 'nage',
    nous: 'nageons',
    vous: 'nagez',
    ils: 'nagent'
  },
  // nager - imparfait
  {
    verbInfinitive: 'nager',
    tense: 'imparfait',
    je: 'nageais',
    tu: 'nageais',
    il: 'nageait',
    nous: 'nagions',
    vous: 'nagiez',
    ils: 'nageaient'
  },
  // nager - futur simple
  {
    verbInfinitive: 'nager',
    tense: 'futur_simple',
    je: 'nagerai',
    tu: 'nageras',
    il: 'nagera',
    nous: 'nagerons',
    vous: 'nagerez',
    ils: 'nageront'
  },

  // voyager - present
  {
    verbInfinitive: 'voyager',
    tense: 'present',
    je: 'voyage',
    tu: 'voyages',
    il: 'voyage',
    nous: 'voyageons',
    vous: 'voyagez',
    ils: 'voyagent'
  },
  // voyager - imparfait
  {
    verbInfinitive: 'voyager',
    tense: 'imparfait',
    je: 'voyageais',
    tu: 'voyageais',
    il: 'voyageait',
    nous: 'voyagions',
    vous: 'voyagiez',
    ils: 'voyageaient'
  },
  // voyager - futur simple
  {
    verbInfinitive: 'voyager',
    tense: 'futur_simple',
    je: 'voyagerai',
    tu: 'voyageras',
    il: 'voyagera',
    nous: 'voyagerons',
    vous: 'voyagerez',
    ils: 'voyageront'
  },

  // partager - present
  {
    verbInfinitive: 'partager',
    tense: 'present',
    je: 'partage',
    tu: 'partages',
    il: 'partage',
    nous: 'partageons',
    vous: 'partagez',
    ils: 'partagent'
  },
  // partager - imparfait
  {
    verbInfinitive: 'partager',
    tense: 'imparfait',
    je: 'partageais',
    tu: 'partageais',
    il: 'partageait',
    nous: 'partagions',
    vous: 'partagiez',
    ils: 'partageaient'
  },
  // partager - futur simple
  {
    verbInfinitive: 'partager',
    tense: 'futur_simple',
    je: 'partagerai',
    tu: 'partageras',
    il: 'partagera',
    nous: 'partagerons',
    vous: 'partagerez',
    ils: 'partageront'
  },

  // changer - present
  {
    verbInfinitive: 'changer',
    tense: 'present',
    je: 'change',
    tu: 'changes',
    il: 'change',
    nous: 'changeons',
    vous: 'changez',
    ils: 'changent'
  },
  // changer - imparfait
  {
    verbInfinitive: 'changer',
    tense: 'imparfait',
    je: 'changeais',
    tu: 'changeais',
    il: 'changeait',
    nous: 'changions',
    vous: 'changiez',
    ils: 'changeaient'
  },
  // changer - futur simple
  {
    verbInfinitive: 'changer',
    tense: 'futur_simple',
    je: 'changerai',
    tu: 'changeras',
    il: 'changera',
    nous: 'changerons',
    vous: 'changerez',
    ils: 'changeront'
  },

  // bouger - present
  {
    verbInfinitive: 'bouger',
    tense: 'present',
    je: 'bouge',
    tu: 'bouges',
    il: 'bouge',
    nous: 'bougeons',
    vous: 'bougez',
    ils: 'bougent'
  },
  // bouger - imparfait
  {
    verbInfinitive: 'bouger',
    tense: 'imparfait',
    je: 'bougeais',
    tu: 'bougeais',
    il: 'bougeait',
    nous: 'bougions',
    vous: 'bougiez',
    ils: 'bougeaient'
  },
  // bouger - futur simple
  {
    verbInfinitive: 'bouger',
    tense: 'futur_simple',
    je: 'bougerai',
    tu: 'bougeras',
    il: 'bougera',
    nous: 'bougerons',
    vous: 'bougerez',
    ils: 'bougeront'
  },

  // Group 2 -ir verbs conjugations
  
  // choisir - present
  {
    verbInfinitive: 'choisir',
    tense: 'present',
    je: 'choisis',
    tu: 'choisis',
    il: 'choisit',
    nous: 'choisissons',
    vous: 'choisissez',
    ils: 'choisissent'
  },
  // choisir - imparfait
  {
    verbInfinitive: 'choisir',
    tense: 'imparfait',
    je: 'choisissais',
    tu: 'choisissais',
    il: 'choisissait',
    nous: 'choisissions',
    vous: 'choisissiez',
    ils: 'choisissaient'
  },
  // choisir - futur simple
  {
    verbInfinitive: 'choisir',
    tense: 'futur_simple',
    je: 'choisirai',
    tu: 'choisiras',
    il: 'choisira',
    nous: 'choisirons',
    vous: 'choisirez',
    ils: 'choisiront'
  },

  // réfléchir - present
  {
    verbInfinitive: 'réfléchir',
    tense: 'present',
    je: 'réfléchis',
    tu: 'réfléchis',
    il: 'réfléchit',
    nous: 'réfléchissons',
    vous: 'réfléchissez',
    ils: 'réfléchissent'
  },
  // réfléchir - imparfait
  {
    verbInfinitive: 'réfléchir',
    tense: 'imparfait',
    je: 'réfléchissais',
    tu: 'réfléchissais',
    il: 'réfléchissait',
    nous: 'réfléchissions',
    vous: 'réfléchissiez',
    ils: 'réfléchissaient'
  },
  // réfléchir - futur simple
  {
    verbInfinitive: 'réfléchir',
    tense: 'futur_simple',
    je: 'réfléchirai',
    tu: 'réfléchiras',
    il: 'réfléchira',
    nous: 'réfléchirons',
    vous: 'réfléchirez',
    ils: 'réfléchiront'
  },

  // réussir - present
  {
    verbInfinitive: 'réussir',
    tense: 'present',
    je: 'réussis',
    tu: 'réussis',
    il: 'réussit',
    nous: 'réussissons',
    vous: 'réussissez',
    ils: 'réussissent'
  },
  // réussir - imparfait
  {
    verbInfinitive: 'réussir',
    tense: 'imparfait',
    je: 'réussissais',
    tu: 'réussissais',
    il: 'réussissait',
    nous: 'réussissions',
    vous: 'réussissiez',
    ils: 'réussissaient'
  },
  // réussir - futur simple
  {
    verbInfinitive: 'réussir',
    tense: 'futur_simple',
    je: 'réussirai',
    tu: 'réussiras',
    il: 'réussira',
    nous: 'réussirons',
    vous: 'réussirez',
    ils: 'réussiront'
  },

  // grandir - present
  {
    verbInfinitive: 'grandir',
    tense: 'present',
    je: 'grandis',
    tu: 'grandis',
    il: 'grandit',
    nous: 'grandissons',
    vous: 'grandissez',
    ils: 'grandissent'
  },
  // grandir - imparfait
  {
    verbInfinitive: 'grandir',
    tense: 'imparfait',
    je: 'grandissais',
    tu: 'grandissais',
    il: 'grandissait',
    nous: 'grandissions',
    vous: 'grandissiez',
    ils: 'grandissaient'
  },
  // grandir - futur simple
  {
    verbInfinitive: 'grandir',
    tense: 'futur_simple',
    je: 'grandirai',
    tu: 'grandiras',
    il: 'grandira',
    nous: 'grandirons',
    vous: 'grandirez',
    ils: 'grandiront'
  },

  // servir - present
  {
    verbInfinitive: 'servir',
    tense: 'present',
    je: 'sers',
    tu: 'sers',
    il: 'sert',
    nous: 'servons',
    vous: 'servez',
    ils: 'servent'
  },
  // servir - imparfait
  {
    verbInfinitive: 'servir',
    tense: 'imparfait',
    je: 'servais',
    tu: 'servais',
    il: 'servait',
    nous: 'servions',
    vous: 'serviez',
    ils: 'servaient'
  },
  // servir - futur simple
  {
    verbInfinitive: 'servir',
    tense: 'futur_simple',
    je: 'servirai',
    tu: 'serviras',
    il: 'servira',
    nous: 'servirons',
    vous: 'servirez',
    ils: 'serviront'
  },

  // Group 3 irregular verbs conjugations
  
  // mentir - present
  {
    verbInfinitive: 'mentir',
    tense: 'present',
    je: 'mens',
    tu: 'mens',
    il: 'ment',
    nous: 'mentons',
    vous: 'mentez',
    ils: 'mentent'
  },
  // mentir - imparfait
  {
    verbInfinitive: 'mentir',
    tense: 'imparfait',
    je: 'mentais',
    tu: 'mentais',
    il: 'mentait',
    nous: 'mentions',
    vous: 'mentiez',
    ils: 'mentaient'
  },
  // mentir - futur simple
  {
    verbInfinitive: 'mentir',
    tense: 'futur_simple',
    je: 'mentirai',
    tu: 'mentiras',
    il: 'mentira',
    nous: 'mentirons',
    vous: 'mentirez',
    ils: 'mentiront'
  },

  // souffrir - present
  {
    verbInfinitive: 'souffrir',
    tense: 'present',
    je: 'souffre',
    tu: 'souffres',
    il: 'souffre',
    nous: 'souffrons',
    vous: 'souffrez',
    ils: 'souffrent'
  },
  // souffrir - imparfait
  {
    verbInfinitive: 'souffrir',
    tense: 'imparfait',
    je: 'souffrais',
    tu: 'souffrais',
    il: 'souffrait',
    nous: 'souffrions',
    vous: 'souffriez',
    ils: 'souffraient'
  },
  // souffrir - futur simple
  {
    verbInfinitive: 'souffrir',
    tense: 'futur_simple',
    je: 'souffrirai',
    tu: 'souffriras',
    il: 'souffrira',
    nous: 'souffrirons',
    vous: 'souffrirez',
    ils: 'souffriront'
  },

  // couvrir - present
  {
    verbInfinitive: 'couvrir',
    tense: 'present',
    je: 'couvre',
    tu: 'couvres',
    il: 'couvre',
    nous: 'couvrons',
    vous: 'couvrez',
    ils: 'couvrent'
  },
  // couvrir - imparfait
  {
    verbInfinitive: 'couvrir',
    tense: 'imparfait',
    je: 'couvrais',
    tu: 'couvrais',
    il: 'couvrait',
    nous: 'couvrions',
    vous: 'couvriez',
    ils: 'couvraient'
  },
  // couvrir - futur simple
  {
    verbInfinitive: 'couvrir',
    tense: 'futur_simple',
    je: 'couvrirai',
    tu: 'couvriras',
    il: 'couvrira',
    nous: 'couvrirons',
    vous: 'couvrirez',
    ils: 'couvriront'
  },

  // découvrir - present
  {
    verbInfinitive: 'découvrir',
    tense: 'present',
    je: 'découvre',
    tu: 'découvres',
    il: 'découvre',
    nous: 'découvrons',
    vous: 'découvrez',
    ils: 'découvrent'
  },
  // découvrir - imparfait
  {
    verbInfinitive: 'découvrir',
    tense: 'imparfait',
    je: 'découvrais',
    tu: 'découvrais',
    il: 'découvrait',
    nous: 'découvrions',
    vous: 'découvriez',
    ils: 'découvraient'
  },
  // découvrir - futur simple
  {
    verbInfinitive: 'découvrir',
    tense: 'futur_simple',
    je: 'découvrirai',
    tu: 'découvriras',
    il: 'découvrira',
    nous: 'découvrirons',
    vous: 'découvrirez',
    ils: 'découvriront'
  },

  // cueillir - present
  {
    verbInfinitive: 'cueillir',
    tense: 'present',
    je: 'cueille',
    tu: 'cueilles',
    il: 'cueille',
    nous: 'cueillons',
    vous: 'cueillez',
    ils: 'cueillent'
  },
  // cueillir - imparfait
  {
    verbInfinitive: 'cueillir',
    tense: 'imparfait',
    je: 'cueillais',
    tu: 'cueillais',
    il: 'cueillait',
    nous: 'cueillions',
    vous: 'cueilliez',
    ils: 'cueillaient'
  },
  // cueillir - futur simple
  {
    verbInfinitive: 'cueillir',
    tense: 'futur_simple',
    je: 'cueillerai',
    tu: 'cueilleras',
    il: 'cueillera',
    nous: 'cueillerons',
    vous: 'cueillerez',
    ils: 'cueilleront'
  },

  // Additional verbs conjugations
  
  // abandonner - present
  {
    verbInfinitive: 'abandonner',
    tense: 'present',
    je: 'abandonne',
    tu: 'abandonnes',
    il: 'abandonne',
    nous: 'abandonnons',
    vous: 'abandonnez',
    ils: 'abandonnent'
  },
  // abandonner - imparfait
  {
    verbInfinitive: 'abandonner',
    tense: 'imparfait',
    je: 'abandonnais',
    tu: 'abandonnais',
    il: 'abandonnait',
    nous: 'abandonnions',
    vous: 'abandonniez',
    ils: 'abandonnaient'
  },
  // abandonner - futur simple
  {
    verbInfinitive: 'abandonner',
    tense: 'futur_simple',
    je: 'abandonnerai',
    tu: 'abandonneras',
    il: 'abandonnera',
    nous: 'abandonnerons',
    vous: 'abandonnerez',
    ils: 'abandonneront'
  },

  // accepter - present
  {
    verbInfinitive: 'accepter',
    tense: 'present',
    je: 'accepte',
    tu: 'acceptes',
    il: 'accepte',
    nous: 'acceptons',
    vous: 'acceptez',
    ils: 'acceptent'
  },
  // accepter - imparfait
  {
    verbInfinitive: 'accepter',
    tense: 'imparfait',
    je: 'acceptais',
    tu: 'acceptais',
    il: 'acceptait',
    nous: 'acceptions',
    vous: 'acceptiez',
    ils: 'acceptaient'
  },
  // accepter - futur simple
  {
    verbInfinitive: 'accepter',
    tense: 'futur_simple',
    je: 'accepterai',
    tu: 'accepteras',
    il: 'acceptera',
    nous: 'accepterons',
    vous: 'accepterez',
    ils: 'accepteront'
  },

  // accompagner - present
  {
    verbInfinitive: 'accompagner',
    tense: 'present',
    je: 'accompagne',
    tu: 'accompagnes',
    il: 'accompagne',
    nous: 'accompagnons',
    vous: 'accompagnez',
    ils: 'accompagnent'
  },
  // accompagner - imparfait
  {
    verbInfinitive: 'accompagner',
    tense: 'imparfait',
    je: 'accompagnais',
    tu: 'accompagnais',
    il: 'accompagnait',
    nous: 'accompagnions',
    vous: 'accompagniez',
    ils: 'accompagnaient'
  },
  // accompagner - futur simple
  {
    verbInfinitive: 'accompagner',
    tense: 'futur_simple',
    je: 'accompagnerai',
    tu: 'accompagneras',
    il: 'accompagnera',
    nous: 'accompagnerons',
    vous: 'accompagnerez',
    ils: 'accompagneront'
  },

  // accueillir - present
  {
    verbInfinitive: 'accueillir',
    tense: 'present',
    je: 'accueille',
    tu: 'accueilles',
    il: 'accueille',
    nous: 'accueillons',
    vous: 'accueillez',
    ils: 'accueillent'
  },
  // accueillir - imparfait
  {
    verbInfinitive: 'accueillir',
    tense: 'imparfait',
    je: 'accueillais',
    tu: 'accueillais',
    il: 'accueillait',
    nous: 'accueillions',
    vous: 'accueilliez',
    ils: 'accueillaient'
  },
  // accueillir - futur simple
  {
    verbInfinitive: 'accueillir',
    tense: 'futur_simple',
    je: 'accueillerai',
    tu: 'accueilleras',
    il: 'accueillera',
    nous: 'accueillerons',
    vous: 'accueillerez',
    ils: 'accueilleront'
  },

  // acheter - present
  {
    verbInfinitive: 'acheter',
    tense: 'present',
    je: 'achète',
    tu: 'achètes',
    il: 'achète',
    nous: 'achetons',
    vous: 'achetez',
    ils: 'achètent'
  },
  // acheter - imparfait
  {
    verbInfinitive: 'acheter',
    tense: 'imparfait',
    je: 'achetais',
    tu: 'achetais',
    il: 'achetait',
    nous: 'achetions',
    vous: 'achetiez',
    ils: 'achetaient'
  },
  // acheter - futur simple
  {
    verbInfinitive: 'acheter',
    tense: 'futur_simple',
    je: 'achèterai',
    tu: 'achèteras',
    il: 'achètera',
    nous: 'achèterons',
    vous: 'achèterez',
    ils: 'achèteront'
  },

  // adorer - present
  {
    verbInfinitive: 'adorer',
    tense: 'present',
    je: 'adore',
    tu: 'adores',
    il: 'adore',
    nous: 'adorons',
    vous: 'adorez',
    ils: 'adorent'
  },
  // adorer - imparfait
  {
    verbInfinitive: 'adorer',
    tense: 'imparfait',
    je: 'adorais',
    tu: 'adorais',
    il: 'adorait',
    nous: 'adorions',
    vous: 'adoriez',
    ils: 'adoraient'
  },
  // adorer - futur simple
  {
    verbInfinitive: 'adorer',
    tense: 'futur_simple',
    je: 'adorerai',
    tu: 'adoreras',
    il: 'adorera',
    nous: 'adorerons',
    vous: 'adorerez',
    ils: 'adoreront'
  },

  // aimer - present
  {
    verbInfinitive: 'aimer',
    tense: 'present',
    je: 'aime',
    tu: 'aimes',
    il: 'aime',
    nous: 'aimons',
    vous: 'aimez',
    ils: 'aiment'
  },
  // aimer - imparfait
  {
    verbInfinitive: 'aimer',
    tense: 'imparfait',
    je: 'aimais',
    tu: 'aimais',
    il: 'aimait',
    nous: 'aimions',
    vous: 'aimiez',
    ils: 'aimaient'
  },
  // aimer - futur simple
  {
    verbInfinitive: 'aimer',
    tense: 'futur_simple',
    je: 'aimerai',
    tu: 'aimeras',
    il: 'aimera',
    nous: 'aimerons',
    vous: 'aimerez',
    ils: 'aimeront'
  },

  // annoncer - present
  {
    verbInfinitive: 'annoncer',
    tense: 'present',
    je: 'annonce',
    tu: 'annonces',
    il: 'annonce',
    nous: 'annonçons',
    vous: 'annoncez',
    ils: 'annoncent'
  },
  // annoncer - imparfait
  {
    verbInfinitive: 'annoncer',
    tense: 'imparfait',
    je: 'annonçais',
    tu: 'annonçais',
    il: 'annonçait',
    nous: 'annoncions',
    vous: 'annonciez',
    ils: 'annonçaient'
  },
  // annoncer - futur simple
  {
    verbInfinitive: 'annoncer',
    tense: 'futur_simple',
    je: 'annoncerai',
    tu: 'annonceras',
    il: 'annoncera',
    nous: 'annoncerons',
    vous: 'annoncerez',
    ils: 'annonceront'
  },

  // apparaître - present
  {
    verbInfinitive: 'apparaître',
    tense: 'present',
    je: 'apparaîs',
    tu: 'apparaîs',
    il: 'apparaît',
    nous: 'apparaissons',
    vous: 'apparaissez',
    ils: 'apparaissent'
  },
  // apparaître - imparfait
  {
    verbInfinitive: 'apparaître',
    tense: 'imparfait',
    je: 'apparaissais',
    tu: 'apparaissais',
    il: 'apparaissait',
    nous: 'apparaissions',
    vous: 'apparaissiez',
    ils: 'apparaissaient'
  },
  // apparaître - futur simple
  {
    verbInfinitive: 'apparaître',
    tense: 'futur_simple',
    je: 'apparaîtrai',
    tu: 'apparaîtras',
    il: 'apparaîtra',
    nous: 'apparaîtrons',
    vous: 'apparaîtrez',
    ils: 'apparaîtront'
  },

  // appartenir - present
  {
    verbInfinitive: 'appartenir',
    tense: 'present',
    je: 'appartiens',
    tu: 'appartiens',
    il: 'appartient',
    nous: 'appartenons',
    vous: 'appartenez',
    ils: 'appartiennent'
  },
  // appartenir - imparfait
  {
    verbInfinitive: 'appartenir',
    tense: 'imparfait',
    je: 'appartenais',
    tu: 'appartenais',
    il: 'appartenait',
    nous: 'appartenions',
    vous: 'apparteniez',
    ils: 'appartenaient'
  },
  // appartenir - futur simple
  {
    verbInfinitive: 'appartenir',
    tense: 'futur_simple',
    je: 'appartiendrai',
    tu: 'appartiendras',
    il: 'appartiendra',
    nous: 'appartiendrons',
    vous: 'appartiendrez',
    ils: 'appartiendront'
  },

  // appeler - present
  {
    verbInfinitive: 'appeler',
    tense: 'present',
    je: 'appelle',
    tu: 'appelles',
    il: 'appelle',
    nous: 'appelons',
    vous: 'appelez',
    ils: 'appellent'
  },
  // appeler - imparfait
  {
    verbInfinitive: 'appeler',
    tense: 'imparfait',
    je: 'appelais',
    tu: 'appelais',
    il: 'appelait',
    nous: 'appelions',
    vous: 'appeliez',
    ils: 'appelaient'
  },
  // appeler - futur simple
  {
    verbInfinitive: 'appeler',
    tense: 'futur_simple',
    je: 'appellerai',
    tu: 'appelleras',
    il: 'appellera',
    nous: 'appellerons',
    vous: 'appellerez',
    ils: 'appelleront'
  },

  // apporter - present
  {
    verbInfinitive: 'apporter',
    tense: 'present',
    je: 'apporte',
    tu: 'apportes',
    il: 'apporte',
    nous: 'apportons',
    vous: 'apportez',
    ils: 'apportent'
  },
  // apporter - imparfait
  {
    verbInfinitive: 'apporter',
    tense: 'imparfait',
    je: 'apportais',
    tu: 'apportais',
    il: 'apportait',
    nous: 'apportions',
    vous: 'apportiez',
    ils: 'apportaient'
  },
  // apporter - futur simple
  {
    verbInfinitive: 'apporter',
    tense: 'futur_simple',
    je: 'apporterai',
    tu: 'apporteras',
    il: 'apportera',
    nous: 'apporterons',
    vous: 'apporterez',
    ils: 'apporteront'
  },

  // apprendre - present
  {
    verbInfinitive: 'apprendre',
    tense: 'present',
    je: 'apprends',
    tu: 'apprends',
    il: 'apprend',
    nous: 'apprenons',
    vous: 'apprenez',
    ils: 'apprennent'
  },
  // apprendre - imparfait
  {
    verbInfinitive: 'apprendre',
    tense: 'imparfait',
    je: 'apprenais',
    tu: 'apprenais',
    il: 'apprenait',
    nous: 'apprenions',
    vous: 'appreniez',
    ils: 'apprenaient'
  },
  // apprendre - futur simple
  {
    verbInfinitive: 'apprendre',
    tense: 'futur_simple',
    je: 'apprendrai',
    tu: 'apprendras',
    il: 'apprendra',
    nous: 'apprendrons',
    vous: 'apprendrez',
    ils: 'apprendront'
  },

  // arrêter - present
  {
    verbInfinitive: 'arrêter',
    tense: 'present',
    je: 'arrête',
    tu: 'arrêtes',
    il: 'arrête',
    nous: 'arrêtons',
    vous: 'arrêtez',
    ils: 'arrêtent'
  },
  // arrêter - imparfait
  {
    verbInfinitive: 'arrêter',
    tense: 'imparfait',
    je: 'arrêtais',
    tu: 'arrêtais',
    il: 'arrêtait',
    nous: 'arrêtions',
    vous: 'arrêtiez',
    ils: 'arrêtaient'
  },
  // arrêter - futur simple
  {
    verbInfinitive: 'arrêter',
    tense: 'futur_simple',
    je: 'arrêterai',
    tu: 'arrêteras',
    il: 'arrêtera',
    nous: 'arrêterons',
    vous: 'arrêterez',
    ils: 'arrêteront'
  },

  // boire - present
  {
    verbInfinitive: 'boire',
    tense: 'present',
    je: 'bois',
    tu: 'bois',
    il: 'boit',
    nous: 'buvons',
    vous: 'buvez',
    ils: 'boivent'
  },
  // boire - imparfait
  {
    verbInfinitive: 'boire',
    tense: 'imparfait',
    je: 'buvais',
    tu: 'buvais',
    il: 'buvait',
    nous: 'buvions',
    vous: 'buviez',
    ils: 'buvaient'
  },
  // boire - futur simple
  {
    verbInfinitive: 'boire',
    tense: 'futur_simple',
    je: 'boirai',
    tu: 'boiras',
    il: 'boira',
    nous: 'boirons',
    vous: 'boirez',
    ils: 'boiront'
  },

  // assaillir - present
  {
    verbInfinitive: 'assaillir',
    tense: 'present',
    je: 'assaille',
    tu: 'assailles',
    il: 'assaille',
    nous: 'assaillons',
    vous: 'assaillez',
    ils: 'assaillent'
  },
  // assaillir - imparfait
  {
    verbInfinitive: 'assaillir',
    tense: 'imparfait',
    je: 'assaillais',
    tu: 'assaillais',
    il: 'assaillait',
    nous: 'assaillions',
    vous: 'assailliez',
    ils: 'assaillaient'
  },
  // assaillir - futur simple
  {
    verbInfinitive: 'assaillir',
    tense: 'futur_simple',
    je: 'assaillirai',
    tu: 'assailliras',
    il: 'assaillira',
    nous: 'assaillirons',
    vous: 'assaillirez',
    ils: 'assailliront'
  },

  // atteindre - present
  {
    verbInfinitive: 'atteindre',
    tense: 'present',
    je: 'atteins',
    tu: 'atteins',
    il: 'atteint',
    nous: 'atteignons',
    vous: 'atteignez',
    ils: 'atteignent'
  },
  // atteindre - imparfait
  {
    verbInfinitive: 'atteindre',
    tense: 'imparfait',
    je: 'atteignais',
    tu: 'atteignais',
    il: 'atteignait',
    nous: 'atteignions',
    vous: 'atteigniez',
    ils: 'atteignaient'
  },
  // atteindre - futur simple
  {
    verbInfinitive: 'atteindre',
    tense: 'futur_simple',
    je: 'atteindrai',
    tu: 'atteindras',
    il: 'atteindra',
    nous: 'atteindrons',
    vous: 'atteindrez',
    ils: 'atteindront'
  },

  // augmenter - present
  {
    verbInfinitive: 'augmenter',
    tense: 'present',
    je: 'augmente',
    tu: 'augmentes',
    il: 'augmente',
    nous: 'augmentons',
    vous: 'augmentez',
    ils: 'augmentent'
  },
  // augmenter - imparfait
  {
    verbInfinitive: 'augmenter',
    tense: 'imparfait',
    je: 'augmentais',
    tu: 'augmentais',
    il: 'augmentait',
    nous: 'augmentions',
    vous: 'augmentiez',
    ils: 'augmentaient'
  },
  // augmenter - futur simple
  {
    verbInfinitive: 'augmenter',
    tense: 'futur_simple',
    je: 'augmenterai',
    tu: 'augmenteras',
    il: 'augmentera',
    nous: 'augmenterons',
    vous: 'augmenterez',
    ils: 'augmenteront'
  },

  // baisser - present
  {
    verbInfinitive: 'baisser',
    tense: 'present',
    je: 'baisse',
    tu: 'baisses',
    il: 'baisse',
    nous: 'baissons',
    vous: 'baissez',
    ils: 'baissent'
  },
  // baisser - imparfait
  {
    verbInfinitive: 'baisser',
    tense: 'imparfait',
    je: 'baissais',
    tu: 'baissais',
    il: 'baissait',
    nous: 'baissions',
    vous: 'baissiez',
    ils: 'baissaient'
  },
  // baisser - futur simple
  {
    verbInfinitive: 'baisser',
    tense: 'futur_simple',
    je: 'baisserai',
    tu: 'baisseras',
    il: 'baissera',
    nous: 'baisserons',
    vous: 'baisserez',
    ils: 'baisseront'
  },

  // casser - present
  {
    verbInfinitive: 'casser',
    tense: 'present',
    je: 'casse',
    tu: 'casses',
    il: 'casse',
    nous: 'cassons',
    vous: 'cassez',
    ils: 'cassent'
  },
  // casser - imparfait
  {
    verbInfinitive: 'casser',
    tense: 'imparfait',
    je: 'cassais',
    tu: 'cassais',
    il: 'cassait',
    nous: 'cassions',
    vous: 'cassiez',
    ils: 'cassaient'
  },
  // casser - futur simple
  {
    verbInfinitive: 'casser',
    tense: 'futur_simple',
    je: 'casserai',
    tu: 'casseras',
    il: 'cassera',
    nous: 'casserons',
    vous: 'casserez',
    ils: 'casseront'
  },

  // célébrer - present
  {
    verbInfinitive: 'célébrer',
    tense: 'present',
    je: 'célèbre',
    tu: 'célèbres',
    il: 'célèbre',
    nous: 'célébrons',
    vous: 'célébrez',
    ils: 'célèbrent'
  },
  // célébrer - imparfait
  {
    verbInfinitive: 'célébrer',
    tense: 'imparfait',
    je: 'célébrais',
    tu: 'célébrais',
    il: 'célébrait',
    nous: 'célébrions',
    vous: 'célébriez',
    ils: 'célébraient'
  },
  // célébrer - futur simple
  {
    verbInfinitive: 'célébrer',
    tense: 'futur_simple',
    je: 'célébrerai',
    tu: 'célébreras',
    il: 'célébrera',
    nous: 'célébrerons',
    vous: 'célébrerez',
    ils: 'célébreront'
  },

  // cesser - present
  {
    verbInfinitive: 'cesser',
    tense: 'present',
    je: 'cesse',
    tu: 'cesses',
    il: 'cesse',
    nous: 'cessons',
    vous: 'cessez',
    ils: 'cessent'
  },
  // cesser - imparfait
  {
    verbInfinitive: 'cesser',
    tense: 'imparfait',
    je: 'cessais',
    tu: 'cessais',
    il: 'cessait',
    nous: 'cessions',
    vous: 'cessiez',
    ils: 'cessaient'
  },
  // cesser - futur simple
  {
    verbInfinitive: 'cesser',
    tense: 'futur_simple',
    je: 'cesserai',
    tu: 'cesseras',
    il: 'cessera',
    nous: 'cesserons',
    vous: 'cesserez',
    ils: 'cesseront'
  },

  // commencer - present
  {
    verbInfinitive: 'commencer',
    tense: 'present',
    je: 'commence',
    tu: 'commences',
    il: 'commence',
    nous: 'commençons',
    vous: 'commencez',
    ils: 'commencent'
  },
  // commencer - imparfait
  {
    verbInfinitive: 'commencer',
    tense: 'imparfait',
    je: 'commençais',
    tu: 'commençais',
    il: 'commençait',
    nous: 'commencions',
    vous: 'commenciez',
    ils: 'commençaient'
  },
  // commencer - futur simple
  {
    verbInfinitive: 'commencer',
    tense: 'futur_simple',
    je: 'commencerai',
    tu: 'commenceras',
    il: 'commencera',
    nous: 'commencerons',
    vous: 'commencerez',
    ils: 'commenceront'
  },

  // conduire - present
  {
    verbInfinitive: 'conduire',
    tense: 'present',
    je: 'conduis',
    tu: 'conduis',
    il: 'conduit',
    nous: 'conduisons',
    vous: 'conduisez',
    ils: 'conduisent'
  },
  // conduire - imparfait
  {
    verbInfinitive: 'conduire',
    tense: 'imparfait',
    je: 'conduisais',
    tu: 'conduisais',
    il: 'conduisait',
    nous: 'conduisions',
    vous: 'conduisiez',
    ils: 'conduisaient'
  },
  // conduire - futur simple
  {
    verbInfinitive: 'conduire',
    tense: 'futur_simple',
    je: 'conduirai',
    tu: 'conduiras',
    il: 'conduira',
    nous: 'conduirons',
    vous: 'conduirez',
    ils: 'conduiront'
  },

  // connaître - present
  {
    verbInfinitive: 'connaître',
    tense: 'present',
    je: 'connais',
    tu: 'connais',
    il: 'connaît',
    nous: 'connaissons',
    vous: 'connaissez',
    ils: 'connaissent'
  },
  // connaître - imparfait
  {
    verbInfinitive: 'connaître',
    tense: 'imparfait',
    je: 'connaissais',
    tu: 'connaissais',
    il: 'connaissait',
    nous: 'connaissions',
    vous: 'connaissiez',
    ils: 'connaissaient'
  },
  // connaître - futur simple
  {
    verbInfinitive: 'connaître',
    tense: 'futur_simple',
    je: 'connaîtrai',
    tu: 'connaîtras',
    il: 'connaîtra',
    nous: 'connaîtrons',
    vous: 'connaîtrez',
    ils: 'connaîtront'
  },

  // considérer - present
  {
    verbInfinitive: 'considérer',
    tense: 'present',
    je: 'considère',
    tu: 'considères',
    il: 'considère',
    nous: 'considérons',
    vous: 'considérez',
    ils: 'considèrent'
  },
  // considérer - imparfait
  {
    verbInfinitive: 'considérer',
    tense: 'imparfait',
    je: 'considérais',
    tu: 'considérais',
    il: 'considérait',
    nous: 'considérions',
    vous: 'considériez',
    ils: 'considéraient'
  },
  // considérer - futur simple
  {
    verbInfinitive: 'considérer',
    tense: 'futur_simple',
    je: 'considérerai',
    tu: 'considéreras',
    il: 'considérera',
    nous: 'considérerons',
    vous: 'considérerez',
    ils: 'considéreront'
  },

  // construire - present
  {
    verbInfinitive: 'construire',
    tense: 'present',
    je: 'construis',
    tu: 'construis',
    il: 'construit',
    nous: 'construisons',
    vous: 'construisez',
    ils: 'construisent'
  },
  // construire - imparfait
  {
    verbInfinitive: 'construire',
    tense: 'imparfait',
    je: 'construisais',
    tu: 'construisais',
    il: 'construisait',
    nous: 'construisions',
    vous: 'construisiez',
    ils: 'construisaient'
  },
  // construire - futur simple
  {
    verbInfinitive: 'construire',
    tense: 'futur_simple',
    je: 'construirai',
    tu: 'construiras',
    il: 'construira',
    nous: 'construirons',
    vous: 'construirez',
    ils: 'construiront'
  },

  // contenir - present
  {
    verbInfinitive: 'contenir',
    tense: 'present',
    je: 'contiens',
    tu: 'contiens',
    il: 'contient',
    nous: 'contenons',
    vous: 'contenez',
    ils: 'contiennent'
  },
  // contenir - imparfait
  {
    verbInfinitive: 'contenir',
    tense: 'imparfait',
    je: 'contenais',
    tu: 'contenais',
    il: 'contenait',
    nous: 'contenions',
    vous: 'conteniez',
    ils: 'contenaient'
  },
  // contenir - futur simple
  {
    verbInfinitive: 'contenir',
    tense: 'futur_simple',
    je: 'contiendrai',
    tu: 'contiendras',
    il: 'contiendra',
    nous: 'contiendrons',
    vous: 'contiendrez',
    ils: 'contiendront'
  },

  // continuer - present
  {
    verbInfinitive: 'continuer',
    tense: 'present',
    je: 'continue',
    tu: 'continues',
    il: 'continue',
    nous: 'continuons',
    vous: 'continuez',
    ils: 'continuent'
  },
  // continuer - imparfait
  {
    verbInfinitive: 'continuer',
    tense: 'imparfait',
    je: 'continuais',
    tu: 'continuais',
    il: 'continuait',
    nous: 'continuions',
    vous: 'continuiez',
    ils: 'continuaient'
  },
  // continuer - futur simple
  {
    verbInfinitive: 'continuer',
    tense: 'futur_simple',
    je: 'continuerai',
    tu: 'continueras',
    il: 'continuera',
    nous: 'continuerons',
    vous: 'continuerez',
    ils: 'continueront'
  },

  // courir - present
  {
    verbInfinitive: 'courir',
    tense: 'present',
    je: 'cours',
    tu: 'cours',
    il: 'court',
    nous: 'courons',
    vous: 'courez',
    ils: 'courent'
  },
  // courir - imparfait
  {
    verbInfinitive: 'courir',
    tense: 'imparfait',
    je: 'courais',
    tu: 'courais',
    il: 'courait',
    nous: 'courions',
    vous: 'couriez',
    ils: 'couraient'
  },
  // courir - futur simple
  {
    verbInfinitive: 'courir',
    tense: 'futur_simple',
    je: 'courrai',
    tu: 'courras',
    il: 'courra',
    nous: 'courrons',
    vous: 'courrez',
    ils: 'courront'
  },

  // craindre - present
  {
    verbInfinitive: 'craindre',
    tense: 'present',
    je: 'crains',
    tu: 'crains',
    il: 'craint',
    nous: 'craignons',
    vous: 'craignez',
    ils: 'craignent'
  },
  // craindre - imparfait
  {
    verbInfinitive: 'craindre',
    tense: 'imparfait',
    je: 'craignais',
    tu: 'craignais',
    il: 'craignait',
    nous: 'craignions',
    vous: 'craigniez',
    ils: 'craignaient'
  },
  // craindre - futur simple
  {
    verbInfinitive: 'craindre',
    tense: 'futur_simple',
    je: 'craindrai',
    tu: 'craindras',
    il: 'craindra',
    nous: 'craindrons',
    vous: 'craindrez',
    ils: 'craindront'
  },

  // créer - present
  {
    verbInfinitive: 'créer',
    tense: 'present',
    je: 'crée',
    tu: 'crées',
    il: 'crée',
    nous: 'créons',
    vous: 'créez',
    ils: 'créent'
  },
  // créer - imparfait
  {
    verbInfinitive: 'créer',
    tense: 'imparfait',
    je: 'créais',
    tu: 'créais',
    il: 'créait',
    nous: 'créions',
    vous: 'créiez',
    ils: 'créaient'
  },
  // créer - futur simple
  {
    verbInfinitive: 'créer',
    tense: 'futur_simple',
    je: 'créerai',
    tu: 'créeras',
    il: 'créera',
    nous: 'créerons',
    vous: 'créerez',
    ils: 'créeront'
  },

  // croire - present
  {
    verbInfinitive: 'croire',
    tense: 'present',
    je: 'crois',
    tu: 'crois',
    il: 'croit',
    nous: 'croyons',
    vous: 'croyez',
    ils: 'croient'
  },
  // croire - imparfait
  {
    verbInfinitive: 'croire',
    tense: 'imparfait',
    je: 'croyais',
    tu: 'croyais',
    il: 'croyait',
    nous: 'croyions',
    vous: 'croyiez',
    ils: 'croyaient'
  },
  // croire - futur simple
  {
    verbInfinitive: 'croire',
    tense: 'futur_simple',
    je: 'croirai',
    tu: 'croiras',
    il: 'croira',
    nous: 'croirons',
    vous: 'croirez',
    ils: 'croiront'
  },

  // croître - present
  {
    verbInfinitive: 'croître',
    tense: 'present',
    je: 'croîs',
    tu: 'croîs',
    il: 'croît',
    nous: 'croissons',
    vous: 'croissez',
    ils: 'croissent'
  },
  // croître - imparfait
  {
    verbInfinitive: 'croître',
    tense: 'imparfait',
    je: 'croissais',
    tu: 'croissais',
    il: 'croissait',
    nous: 'croissions',
    vous: 'croissiez',
    ils: 'croissaient'
  },
  // croître - futur simple
  {
    verbInfinitive: 'croître',
    tense: 'futur_simple',
    je: 'croîtrai',
    tu: 'croîtras',
    il: 'croîtra',
    nous: 'croîtrons',
    vous: 'croîtrez',
    ils: 'croîtront'
  },

  // cuire - present
  {
    verbInfinitive: 'cuire',
    tense: 'present',
    je: 'cuis',
    tu: 'cuis',
    il: 'cuit',
    nous: 'cuisons',
    vous: 'cuisez',
    ils: 'cuisent'
  },
  // cuire - imparfait
  {
    verbInfinitive: 'cuire',
    tense: 'imparfait',
    je: 'cuisais',
    tu: 'cuisais',
    il: 'cuisait',
    nous: 'cuisions',
    vous: 'cuisiez',
    ils: 'cuisaient'
  },
  // cuire - futur simple
  {
    verbInfinitive: 'cuire',
    tense: 'futur_simple',
    je: 'cuirai',
    tu: 'cuiras',
    il: 'cuira',
    nous: 'cuirons',
    vous: 'cuirez',
    ils: 'cuiront'
  },

  // danser - present
  {
    verbInfinitive: 'danser',
    tense: 'present',
    je: 'danse',
    tu: 'danses',
    il: 'danse',
    nous: 'dansons',
    vous: 'dansez',
    ils: 'dansent'
  },
  // danser - imparfait
  {
    verbInfinitive: 'danser',
    tense: 'imparfait',
    je: 'dansais',
    tu: 'dansais',
    il: 'dansait',
    nous: 'dansions',
    vous: 'dansiez',
    ils: 'dansaient'
  },
  // danser - futur simple
  {
    verbInfinitive: 'danser',
    tense: 'futur_simple',
    je: 'danserai',
    tu: 'danseras',
    il: 'dansera',
    nous: 'danserons',
    vous: 'danserez',
    ils: 'danseront'
  },

  // décider - present
  {
    verbInfinitive: 'décider',
    tense: 'present',
    je: 'décide',
    tu: 'décides',
    il: 'décide',
    nous: 'décidons',
    vous: 'décidez',
    ils: 'décident'
  },
  // décider - imparfait
  {
    verbInfinitive: 'décider',
    tense: 'imparfait',
    je: 'décidais',
    tu: 'décidais',
    il: 'décidait',
    nous: 'décidions',
    vous: 'décidiez',
    ils: 'décidaient'
  },
  // décider - futur simple
  {
    verbInfinitive: 'décider',
    tense: 'futur_simple',
    je: 'déciderai',
    tu: 'décideras',
    il: 'décidera',
    nous: 'déciderons',
    vous: 'déciderez',
    ils: 'décideront'
  },

  // désirer - present
  {
    verbInfinitive: 'désirer',
    tense: 'present',
    je: 'désire',
    tu: 'désires',
    il: 'désire',
    nous: 'désirons',
    vous: 'désirez',
    ils: 'désirent'
  },
  // désirer - imparfait
  {
    verbInfinitive: 'désirer',
    tense: 'imparfait',
    je: 'désirais',
    tu: 'désirais',
    il: 'désirait',
    nous: 'désirions',
    vous: 'désiriez',
    ils: 'désiraient'
  },
  // désirer - futur simple
  {
    verbInfinitive: 'désirer',
    tense: 'futur_simple',
    je: 'désirerai',
    tu: 'désireras',
    il: 'désirera',
    nous: 'désirerons',
    vous: 'désirerez',
    ils: 'désireront'
  },

  // détester - present
  {
    verbInfinitive: 'détester',
    tense: 'present',
    je: 'déteste',
    tu: 'détestes',
    il: 'déteste',
    nous: 'détestons',
    vous: 'détestez',
    ils: 'détestent'
  },
  // détester - imparfait
  {
    verbInfinitive: 'détester',
    tense: 'imparfait',
    je: 'détestais',
    tu: 'détestais',
    il: 'détestait',
    nous: 'détestions',
    vous: 'détestiez',
    ils: 'détestaient'
  },
  // détester - futur simple
  {
    verbInfinitive: 'détester',
    tense: 'futur_simple',
    je: 'détesterai',
    tu: 'détesteras',
    il: 'détestera',
    nous: 'détesterons',
    vous: 'détesterez',
    ils: 'détesteront'
  },

  // détruire - present
  {
    verbInfinitive: 'détruire',
    tense: 'present',
    je: 'détruis',
    tu: 'détruis',
    il: 'détruit',
    nous: 'détruisons',
    vous: 'détruisez',
    ils: 'détruisent'
  },
  // détruire - imparfait
  {
    verbInfinitive: 'détruire',
    tense: 'imparfait',
    je: 'détruisais',
    tu: 'détruisais',
    il: 'détruisait',
    nous: 'détruisions',
    vous: 'détruisiez',
    ils: 'détruisaient'
  },
  // détruire - futur simple
  {
    verbInfinitive: 'détruire',
    tense: 'futur_simple',
    je: 'détruirai',
    tu: 'détruiras',
    il: 'détruira',
    nous: 'détruirons',
    vous: 'détruirez',
    ils: 'détruiront'
  },

  // développer - present
  {
    verbInfinitive: 'développer',
    tense: 'present',
    je: 'développe',
    tu: 'développes',
    il: 'développe',
    nous: 'développons',
    vous: 'développez',
    ils: 'développent'
  },
  // développer - imparfait
  {
    verbInfinitive: 'développer',
    tense: 'imparfait',
    je: 'développais',
    tu: 'développais',
    il: 'développait',
    nous: 'développions',
    vous: 'développiez',
    ils: 'développaient'
  },
  // développer - futur simple
  {
    verbInfinitive: 'développer',
    tense: 'futur_simple',
    je: 'développerai',
    tu: 'développeras',
    il: 'développera',
    nous: 'développerons',
    vous: 'développerez',
    ils: 'développeront'
  },

  // devenir - present
  {
    verbInfinitive: 'devenir',
    tense: 'present',
    je: 'deviens',
    tu: 'deviens',
    il: 'devient',
    nous: 'devenons',
    vous: 'devenez',
    ils: 'deviennent'
  },
  // devenir - imparfait
  {
    verbInfinitive: 'devenir',
    tense: 'imparfait',
    je: 'devenais',
    tu: 'devenais',
    il: 'devenait',
    nous: 'devenions',
    vous: 'deveniez',
    ils: 'devenaient'
  },
  // devenir - futur simple
  {
    verbInfinitive: 'devenir',
    tense: 'futur_simple',
    je: 'deviendrai',
    tu: 'deviendras',
    il: 'deviendra',
    nous: 'deviendrons',
    vous: 'deviendrez',
    ils: 'deviendront'
  },

  // devoir - present
  {
    verbInfinitive: 'devoir',
    tense: 'present',
    je: 'dois',
    tu: 'dois',
    il: 'doit',
    nous: 'devons',
    vous: 'devez',
    ils: 'doivent'
  },
  // devoir - imparfait
  {
    verbInfinitive: 'devoir',
    tense: 'imparfait',
    je: 'devais',
    tu: 'devais',
    il: 'devait',
    nous: 'devions',
    vous: 'deviez',
    ils: 'devaient'
  },
  // devoir - futur simple
  {
    verbInfinitive: 'devoir',
    tense: 'futur_simple',
    je: 'devrai',
    tu: 'devras',
    il: 'devra',
    nous: 'devrons',
    vous: 'devrez',
    ils: 'devront'
  },

  // dire - present
  {
    verbInfinitive: 'dire',
    tense: 'present',
    je: 'dis',
    tu: 'dis',
    il: 'dit',
    nous: 'disons',
    vous: 'dites',
    ils: 'disent'
  },
  // dire - imparfait
  {
    verbInfinitive: 'dire',
    tense: 'imparfait',
    je: 'disais',
    tu: 'disais',
    il: 'disait',
    nous: 'disions',
    vous: 'disiez',
    ils: 'disaient'
  },
  // dire - futur simple
  {
    verbInfinitive: 'dire',
    tense: 'futur_simple',
    je: 'dirai',
    tu: 'diras',
    il: 'dira',
    nous: 'dirons',
    vous: 'direz',
    ils: 'diront'
  },

  // discuter - present
  {
    verbInfinitive: 'discuter',
    tense: 'present',
    je: 'discute',
    tu: 'discutes',
    il: 'discute',
    nous: 'discutons',
    vous: 'discutez',
    ils: 'discutent'
  },
  // discuter - imparfait
  {
    verbInfinitive: 'discuter',
    tense: 'imparfait',
    je: 'discutais',
    tu: 'discutais',
    il: 'discutait',
    nous: 'discutions',
    vous: 'discutiez',
    ils: 'discutaient'
  },
  // discuter - futur simple
  {
    verbInfinitive: 'discuter',
    tense: 'futur_simple',
    je: 'discuterai',
    tu: 'discuteras',
    il: 'discutera',
    nous: 'discuterons',
    vous: 'discuterez',
    ils: 'discuteront'
  },

  // disparaître - present
  {
    verbInfinitive: 'disparaître',
    tense: 'present',
    je: 'disparaîs',
    tu: 'disparaîs',
    il: 'disparaît',
    nous: 'disparaissons',
    vous: 'disparaissez',
    ils: 'disparaissent'
  },
  // disparaître - imparfait
  {
    verbInfinitive: 'disparaître',
    tense: 'imparfait',
    je: 'disparaissais',
    tu: 'disparaissais',
    il: 'disparaissait',
    nous: 'disparaissions',
    vous: 'disparaissiez',
    ils: 'disparaissaient'
  },
  // disparaître - futur simple
  {
    verbInfinitive: 'disparaître',
    tense: 'futur_simple',
    je: 'disparaîtrai',
    tu: 'disparaîtras',
    il: 'disparaîtra',
    nous: 'disparaîtrons',
    vous: 'disparaîtrez',
    ils: 'disparaîtront'
  },

  // donner - present
  {
    verbInfinitive: 'donner',
    tense: 'present',
    je: 'donne',
    tu: 'donnes',
    il: 'donne',
    nous: 'donnons',
    vous: 'donnez',
    ils: 'donnent'
  },
  // donner - imparfait
  {
    verbInfinitive: 'donner',
    tense: 'imparfait',
    je: 'donnais',
    tu: 'donnais',
    il: 'donnait',
    nous: 'donnions',
    vous: 'donniez',
    ils: 'donnaient'
  },
  // donner - futur simple
  {
    verbInfinitive: 'donner',
    tense: 'futur_simple',
    je: 'donnerai',
    tu: 'donneras',
    il: 'donnera',
    nous: 'donnerons',
    vous: 'donnerez',
    ils: 'donneront'
  },

  // douter - present
  {
    verbInfinitive: 'douter',
    tense: 'present',
    je: 'doute',
    tu: 'doutes',
    il: 'doute',
    nous: 'doutons',
    vous: 'doutez',
    ils: 'doutent'
  },
  // douter - imparfait
  {
    verbInfinitive: 'douter',
    tense: 'imparfait',
    je: 'doutais',
    tu: 'doutais',
    il: 'doutait',
    nous: 'doutions',
    vous: 'doutiez',
    ils: 'doutaient'
  },
  // douter - futur simple
  {
    verbInfinitive: 'douter',
    tense: 'futur_simple',
    je: 'douterai',
    tu: 'douteras',
    il: 'doutera',
    nous: 'douterons',
    vous: 'douterez',
    ils: 'douteront'
  },

  // envoyer - present
  {
    verbInfinitive: 'envoyer',
    tense: 'present',
    je: 'envoie',
    tu: 'envoies',
    il: 'envoie',
    nous: 'envoyons',
    vous: 'envoyez',
    ils: 'envoient'
  },
  // envoyer - imparfait
  {
    verbInfinitive: 'envoyer',
    tense: 'imparfait',
    je: 'envoyais',
    tu: 'envoyais',
    il: 'envoyait',
    nous: 'envoyions',
    vous: 'envoyiez',
    ils: 'envoyaient'
  },
  // envoyer - futur simple
  {
    verbInfinitive: 'envoyer',
    tense: 'futur_simple',
    je: 'enverrai',
    tu: 'enverras',
    il: 'enverra',
    nous: 'enverrons',
    vous: 'enverrez',
    ils: 'enverront'
  },

  // espérer - present
  {
    verbInfinitive: 'espérer',
    tense: 'present',
    je: 'espère',
    tu: 'espères',
    il: 'espère',
    nous: 'espérons',
    vous: 'espérez',
    ils: 'espèrent'
  },
  // espérer - imparfait
  {
    verbInfinitive: 'espérer',
    tense: 'imparfait',
    je: 'espérais',
    tu: 'espérais',
    il: 'espérait',
    nous: 'espérions',
    vous: 'espériez',
    ils: 'espéraient'
  },
  // espérer - futur simple
  {
    verbInfinitive: 'espérer',
    tense: 'futur_simple',
    je: 'espérerai',
    tu: 'espéreras',
    il: 'espérera',
    nous: 'espérerons',
    vous: 'espérerez',
    ils: 'espéreront'
  },

  // essayer - present
  {
    verbInfinitive: 'essayer',
    tense: 'present',
    je: 'essaie',
    tu: 'essaies',
    il: 'essaie',
    nous: 'essayons',
    vous: 'essayez',
    ils: 'essaient'
  },
  // essayer - imparfait
  {
    verbInfinitive: 'essayer',
    tense: 'imparfait',
    je: 'essayais',
    tu: 'essayais',
    il: 'essayait',
    nous: 'essayions',
    vous: 'essayiez',
    ils: 'essayaient'
  },
  // essayer - futur simple
  {
    verbInfinitive: 'essayer',
    tense: 'futur_simple',
    je: 'essaierai',
    tu: 'essaieras',
    il: 'essaiera',
    nous: 'essaierons',
    vous: 'essaierez',
    ils: 'essaieront'
  },

  // éteindre - present
  {
    verbInfinitive: 'éteindre',
    tense: 'present',
    je: 'éteins',
    tu: 'éteins',
    il: 'éteint',
    nous: 'éteignons',
    vous: 'éteignez',
    ils: 'éteignent'
  },
  // éteindre - imparfait
  {
    verbInfinitive: 'éteindre',
    tense: 'imparfait',
    je: 'éteignais',
    tu: 'éteignais',
    il: 'éteignait',
    nous: 'éteignions',
    vous: 'éteigniez',
    ils: 'éteignaient'
  },
  // éteindre - futur simple
  {
    verbInfinitive: 'éteindre',
    tense: 'futur_simple',
    je: 'éteindrai',
    tu: 'éteindras',
    il: 'éteindra',
    nous: 'éteindrons',
    vous: 'éteindrez',
    ils: 'éteindront'
  },

  // faillir - present
  {
    verbInfinitive: 'faillir',
    tense: 'present',
    je: 'faux',
    tu: 'faux',
    il: 'faut',
    nous: 'faillons',
    vous: 'faillez',
    ils: 'faillent'
  },
  // faillir - imparfait
  {
    verbInfinitive: 'faillir',
    tense: 'imparfait',
    je: 'faillais',
    tu: 'faillais',
    il: 'faillait',
    nous: 'faillions',
    vous: 'failliez',
    ils: 'faillaient'
  },
  // faillir - futur simple
  {
    verbInfinitive: 'faillir',
    tense: 'futur_simple',
    je: 'faudrai',
    tu: 'faudras',
    il: 'faudra',
    nous: 'faudrons',
    vous: 'faudrez',
    ils: 'faudront'
  },

  // falloir - present
  {
    verbInfinitive: 'falloir',
    tense: 'present',
    je: '',
    tu: '',
    il: 'faut',
    nous: '',
    vous: '',
    ils: ''
  },
  // falloir - imparfait
  {
    verbInfinitive: 'falloir',
    tense: 'imparfait',
    je: '',
    tu: '',
    il: 'fallait',
    nous: '',
    vous: '',
    ils: ''
  },
  // falloir - futur simple
  {
    verbInfinitive: 'falloir',
    tense: 'futur_simple',
    je: '',
    tu: '',
    il: 'faudra',
    nous: '',
    vous: '',
    ils: ''
  },

  // introduire - present
  {
    verbInfinitive: 'introduire',
    tense: 'present',
    je: 'introduis',
    tu: 'introduis',
    il: 'introduit',
    nous: 'introduisons',
    vous: 'introduisez',
    ils: 'introduisent'
  },
  // introduire - imparfait
  {
    verbInfinitive: 'introduire',
    tense: 'imparfait',
    je: 'introduisais',
    tu: 'introduisais',
    il: 'introduisait',
    nous: 'introduisions',
    vous: 'introduisiez',
    ils: 'introduisaient'
  },
  // introduire - futur simple
  {
    verbInfinitive: 'introduire',
    tense: 'futur_simple',
    je: 'introduirai',
    tu: 'introduiras',
    il: 'introduira',
    nous: 'introduirons',
    vous: 'introduirez',
    ils: 'introduiront'
  },

  // jeter - present
  {
    verbInfinitive: 'jeter',
    tense: 'present',
    je: 'jette',
    tu: 'jettes',
    il: 'jette',
    nous: 'jetons',
    vous: 'jetez',
    ils: 'jettent'
  },
  // jeter - imparfait
  {
    verbInfinitive: 'jeter',
    tense: 'imparfait',
    je: 'jetais',
    tu: 'jetais',
    il: 'jetait',
    nous: 'jetions',
    vous: 'jetiez',
    ils: 'jetaient'
  },
  // jeter - futur simple
  {
    verbInfinitive: 'jeter',
    tense: 'futur_simple',
    je: 'jetterai',
    tu: 'jetteras',
    il: 'jettera',
    nous: 'jetterons',
    vous: 'jetterez',
    ils: 'jetteront'
  },

  // joindre - present
  {
    verbInfinitive: 'joindre',
    tense: 'present',
    je: 'joins',
    tu: 'joins',
    il: 'joint',
    nous: 'joignons',
    vous: 'joignez',
    ils: 'joignent'
  },
  // joindre - imparfait
  {
    verbInfinitive: 'joindre',
    tense: 'imparfait',
    je: 'joignais',
    tu: 'joignais',
    il: 'joignait',
    nous: 'joignions',
    vous: 'joigniez',
    ils: 'joignaient'
  },
  // joindre - futur simple
  {
    verbInfinitive: 'joindre',
    tense: 'futur_simple',
    je: 'joindrai',
    tu: 'joindras',
    il: 'joindra',
    nous: 'joindrons',
    vous: 'joindrez',
    ils: 'joindront'
  },

  // juger - present
  {
    verbInfinitive: 'juger',
    tense: 'present',
    je: 'juge',
    tu: 'juges',
    il: 'juge',
    nous: 'jugeons',
    vous: 'jugez',
    ils: 'jugent'
  },
  // juger - imparfait
  {
    verbInfinitive: 'juger',
    tense: 'imparfait',
    je: 'jugeais',
    tu: 'jugeais',
    il: 'jugeait',
    nous: 'jugions',
    vous: 'jugiez',
    ils: 'jugeaient'
  },
  // juger - futur simple
  {
    verbInfinitive: 'juger',
    tense: 'futur_simple',
    je: 'jugerai',
    tu: 'jugeras',
    il: 'jugera',
    nous: 'jugerons',
    vous: 'jugerez',
    ils: 'jugeront'
  },

  // maintenir - present
  {
    verbInfinitive: 'maintenir',
    tense: 'present',
    je: 'maintiens',
    tu: 'maintiens',
    il: 'maintient',
    nous: 'maintenons',
    vous: 'maintenez',
    ils: 'maintiennent'
  },
  // maintenir - imparfait
  {
    verbInfinitive: 'maintenir',
    tense: 'imparfait',
    je: 'maintenais',
    tu: 'maintenais',
    il: 'maintenait',
    nous: 'maintenions',
    vous: 'mainteniez',
    ils: 'maintenaient'
  },
  // maintenir - futur simple
  {
    verbInfinitive: 'maintenir',
    tense: 'futur_simple',
    je: 'maintiendrai',
    tu: 'maintiendras',
    il: 'maintiendra',
    nous: 'maintiendrons',
    vous: 'maintiendrez',
    ils: 'maintiendront'
  },

  // manger - present
  {
    verbInfinitive: 'manger',
    tense: 'present',
    je: 'mange',
    tu: 'manges',
    il: 'mange',
    nous: 'mangeons',
    vous: 'mangez',
    ils: 'mangent'
  },
  // manger - imparfait
  {
    verbInfinitive: 'manger',
    tense: 'imparfait',
    je: 'mangeais',
    tu: 'mangeais',
    il: 'mangeait',
    nous: 'mangions',
    vous: 'mangiez',
    ils: 'mangeaient'
  },
  // manger - futur simple
  {
    verbInfinitive: 'manger',
    tense: 'futur_simple',
    je: 'mangerai',
    tu: 'mangeras',
    il: 'mangera',
    nous: 'mangerons',
    vous: 'mangerez',
    ils: 'mangeront'
  },

  // mourir - present
  {
    verbInfinitive: 'mourir',
    tense: 'present',
    je: 'meurs',
    tu: 'meurs',
    il: 'meurt',
    nous: 'mourons',
    vous: 'mourez',
    ils: 'meurent'
  },
  // mourir - imparfait
  {
    verbInfinitive: 'mourir',
    tense: 'imparfait',
    je: 'mourais',
    tu: 'mourais',
    il: 'mourait',
    nous: 'mourions',
    vous: 'mouriez',
    ils: 'mouraient'
  },
  // mourir - futur simple
  {
    verbInfinitive: 'mourir',
    tense: 'futur_simple',
    je: 'mourrai',
    tu: 'mourras',
    il: 'mourra',
    nous: 'mourrons',
    vous: 'mourrez',
    ils: 'mourront'
  },

  // naître - present
  {
    verbInfinitive: 'naître',
    tense: 'present',
    je: 'nais',
    tu: 'nais',
    il: 'naît',
    nous: 'naissons',
    vous: 'naissez',
    ils: 'naissent'
  },
  // naître - imparfait
  {
    verbInfinitive: 'naître',
    tense: 'imparfait',
    je: 'naissais',
    tu: 'naissais',
    il: 'naissait',
    nous: 'naissions',
    vous: 'naissiez',
    ils: 'naissaient'
  },
  // naître - futur simple
  {
    verbInfinitive: 'naître',
    tense: 'futur_simple',
    je: 'naîtrai',
    tu: 'naîtras',
    il: 'naîtra',
    nous: 'naîtrons',
    vous: 'naîtrez',
    ils: 'naîtront'
  },

  // nuire - present
  {
    verbInfinitive: 'nuire',
    tense: 'present',
    je: 'nuis',
    tu: 'nuis',
    il: 'nuit',
    nous: 'nuisons',
    vous: 'nuisez',
    ils: 'nuisent'
  },
  // nuire - imparfait
  {
    verbInfinitive: 'nuire',
    tense: 'imparfait',
    je: 'nuisais',
    tu: 'nuisais',
    il: 'nuisait',
    nous: 'nuisions',
    vous: 'nuisiez',
    ils: 'nuisaient'
  },
  // nuire - futur simple
  {
    verbInfinitive: 'nuire',
    tense: 'futur_simple',
    je: 'nuirai',
    tu: 'nuiras',
    il: 'nuira',
    nous: 'nuirons',
    vous: 'nuirez',
    ils: 'nuiront'
  },

  // obliger - present
  {
    verbInfinitive: 'obliger',
    tense: 'present',
    je: 'oblige',
    tu: 'obliges',
    il: 'oblige',
    nous: 'obligeons',
    vous: 'obligez',
    ils: 'obligent'
  },
  // obliger - imparfait
  {
    verbInfinitive: 'obliger',
    tense: 'imparfait',
    je: 'obligeais',
    tu: 'obligeais',
    il: 'obligeait',
    nous: 'obligions',
    vous: 'obligiez',
    ils: 'obligeaient'
  },
  // obliger - futur simple
  {
    verbInfinitive: 'obliger',
    tense: 'futur_simple',
    je: 'obligerai',
    tu: 'obligeras',
    il: 'obligera',
    nous: 'obligerons',
    vous: 'obligerez',
    ils: 'obligeront'
  },

  // obtenir - present
  {
    verbInfinitive: 'obtenir',
    tense: 'present',
    je: 'obtiens',
    tu: 'obtiens',
    il: 'obtient',
    nous: 'obtenons',
    vous: 'obtenez',
    ils: 'obtiennent'
  },
  // obtenir - imparfait
  {
    verbInfinitive: 'obtenir',
    tense: 'imparfait',
    je: 'obtenais',
    tu: 'obtenais',
    il: 'obtenait',
    nous: 'obtenions',
    vous: 'obteniez',
    ils: 'obtenaient'
  },
  // obtenir - futur simple
  {
    verbInfinitive: 'obtenir',
    tense: 'futur_simple',
    je: 'obtiendrai',
    tu: 'obtiendras',
    il: 'obtiendra',
    nous: 'obtiendrons',
    vous: 'obtiendrez',
    ils: 'obtiendront'
  },

  // paraître - present
  {
    verbInfinitive: 'paraître',
    tense: 'present',
    je: 'parais',
    tu: 'parais',
    il: 'paraît',
    nous: 'paraissons',
    vous: 'paraissez',
    ils: 'paraissent'
  },
  // paraître - imparfait
  {
    verbInfinitive: 'paraître',
    tense: 'imparfait',
    je: 'paraissais',
    tu: 'paraissais',
    il: 'paraissait',
    nous: 'paraissions',
    vous: 'paraissiez',
    ils: 'paraissaient'
  },
  // paraître - futur simple
  {
    verbInfinitive: 'paraître',
    tense: 'futur_simple',
    je: 'paraîtrai',
    tu: 'paraîtras',
    il: 'paraîtra',
    nous: 'paraîtrons',
    vous: 'paraîtrez',
    ils: 'paraîtront'
  },

  // payer - present
  {
    verbInfinitive: 'payer',
    tense: 'present',
    je: 'paie',
    tu: 'paies',
    il: 'paie',
    nous: 'payons',
    vous: 'payez',
    ils: 'paient'
  },
  // payer - imparfait
  {
    verbInfinitive: 'payer',
    tense: 'imparfait',
    je: 'payais',
    tu: 'payais',
    il: 'payait',
    nous: 'payions',
    vous: 'payiez',
    ils: 'payaient'
  },
  // payer - futur simple
  {
    verbInfinitive: 'payer',
    tense: 'futur_simple',
    je: 'paierai',
    tu: 'paieras',
    il: 'paiera',
    nous: 'paierons',
    vous: 'paierez',
    ils: 'paieront'
  },

  // peindre - present
  {
    verbInfinitive: 'peindre',
    tense: 'present',
    je: 'peins',
    tu: 'peins',
    il: 'peint',
    nous: 'peignons',
    vous: 'peignez',
    ils: 'peignent'
  },
  // peindre - imparfait
  {
    verbInfinitive: 'peindre',
    tense: 'imparfait',
    je: 'peignais',
    tu: 'peignais',
    il: 'peignait',
    nous: 'peignions',
    vous: 'peigniez',
    ils: 'peignaient'
  },
  // peindre - futur simple
  {
    verbInfinitive: 'peindre',
    tense: 'futur_simple',
    je: 'peindrai',
    tu: 'peindras',
    il: 'peindra',
    nous: 'peindrons',
    vous: 'peindrez',
    ils: 'peindront'
  },

  // plaindre - present
  {
    verbInfinitive: 'plaindre',
    tense: 'present',
    je: 'plains',
    tu: 'plains',
    il: 'plaint',
    nous: 'plaignons',
    vous: 'plaignez',
    ils: 'plaignent'
  },
  // plaindre - imparfait
  {
    verbInfinitive: 'plaindre',
    tense: 'imparfait',
    je: 'plaignais',
    tu: 'plaignais',
    il: 'plaignait',
    nous: 'plaignions',
    vous: 'plaigniez',
    ils: 'plaignaient'
  },
  // plaindre - futur simple
  {
    verbInfinitive: 'plaindre',
    tense: 'futur_simple',
    je: 'plaindrai',
    tu: 'plaindras',
    il: 'plaindra',
    nous: 'plaindrons',
    vous: 'plaindrez',
    ils: 'plaindront'
  },

  // plaire - present
  {
    verbInfinitive: 'plaire',
    tense: 'present',
    je: 'plais',
    tu: 'plais',
    il: 'plaît',
    nous: 'plaisons',
    vous: 'plaisez',
    ils: 'plaisent'
  },
  // plaire - imparfait
  {
    verbInfinitive: 'plaire',
    tense: 'imparfait',
    je: 'plaisais',
    tu: 'plaisais',
    il: 'plaisait',
    nous: 'plaisions',
    vous: 'plaisiez',
    ils: 'plaisaient'
  },
  // plaire - futur simple
  {
    verbInfinitive: 'plaire',
    tense: 'futur_simple',
    je: 'plairai',
    tu: 'plairas',
    il: 'plaira',
    nous: 'plairons',
    vous: 'plairez',
    ils: 'plairont'
  },

  // pleuvoir - present
  {
    verbInfinitive: 'pleuvoir',
    tense: 'present',
    je: '',
    tu: '',
    il: 'pleut',
    nous: '',
    vous: '',
    ils: 'pleuvent'
  },
  // pleuvoir - imparfait
  {
    verbInfinitive: 'pleuvoir',
    tense: 'imparfait',
    je: '',
    tu: '',
    il: 'pleuvait',
    nous: '',
    vous: '',
    ils: 'pleuvaient'
  },
  // pleuvoir - futur simple
  {
    verbInfinitive: 'pleuvoir',
    tense: 'futur_simple',
    je: '',
    tu: '',
    il: 'pleuvra',
    nous: '',
    vous: '',
    ils: 'pleuvront'
  },

  // plonger - present
  {
    verbInfinitive: 'plonger',
    tense: 'present',
    je: 'plonge',
    tu: 'plonges',
    il: 'plonge',
    nous: 'plongeons',
    vous: 'plongez',
    ils: 'plongent'
  },
  // plonger - imparfait
  {
    verbInfinitive: 'plonger',
    tense: 'imparfait',
    je: 'plongeais',
    tu: 'plongeais',
    il: 'plongeait',
    nous: 'plongions',
    vous: 'plongiez',
    ils: 'plongeaient'
  },
  // plonger - futur simple
  {
    verbInfinitive: 'plonger',
    tense: 'futur_simple',
    je: 'plongerai',
    tu: 'plongeras',
    il: 'plongera',
    nous: 'plongerons',
    vous: 'plongerez',
    ils: 'plongeront'
  },

  // pouvoir - present
  {
    verbInfinitive: 'pouvoir',
    tense: 'present',
    je: 'peux',
    tu: 'peux',
    il: 'peut',
    nous: 'pouvons',
    vous: 'pouvez',
    ils: 'peuvent'
  },
  // pouvoir - imparfait
  {
    verbInfinitive: 'pouvoir',
    tense: 'imparfait',
    je: 'pouvais',
    tu: 'pouvais',
    il: 'pouvait',
    nous: 'pouvions',
    vous: 'pouviez',
    ils: 'pouvaient'
  },
  // pouvoir - futur simple
  {
    verbInfinitive: 'pouvoir',
    tense: 'futur_simple',
    je: 'pourrai',
    tu: 'pourras',
    il: 'pourra',
    nous: 'pourrons',
    vous: 'pourrez',
    ils: 'pourront'
  },

  // préférer - present
  {
    verbInfinitive: 'préférer',
    tense: 'present',
    je: 'préfère',
    tu: 'préfères',
    il: 'préfère',
    nous: 'préférons',
    vous: 'préférez',
    ils: 'préfèrent'
  },
  // préférer - imparfait
  {
    verbInfinitive: 'préférer',
    tense: 'imparfait',
    je: 'préférais',
    tu: 'préférais',
    il: 'préférait',
    nous: 'préférions',
    vous: 'préfériez',
    ils: 'préféraient'
  },
  // préférer - futur simple
  {
    verbInfinitive: 'préférer',
    tense: 'futur_simple',
    je: 'préférerai',
    tu: 'préféreras',
    il: 'préférera',
    nous: 'préférerons',
    vous: 'préférerez',
    ils: 'préféreront'
  },

  // produire - present
  {
    verbInfinitive: 'produire',
    tense: 'present',
    je: 'produis',
    tu: 'produis',
    il: 'produit',
    nous: 'produisons',
    vous: 'produisez',
    ils: 'produisent'
  },
  // produire - imparfait
  {
    verbInfinitive: 'produire',
    tense: 'imparfait',
    je: 'produisais',
    tu: 'produisais',
    il: 'produisait',
    nous: 'produisions',
    vous: 'produisiez',
    ils: 'produisaient'
  },
  // produire - futur simple
  {
    verbInfinitive: 'produire',
    tense: 'futur_simple',
    je: 'produirai',
    tu: 'produiras',
    il: 'produira',
    nous: 'produirons',
    vous: 'produirez',
    ils: 'produiront'
  },

  // protéger - present
  {
    verbInfinitive: 'protéger',
    tense: 'present',
    je: 'protège',
    tu: 'protèges',
    il: 'protège',
    nous: 'protégeons',
    vous: 'protégez',
    ils: 'protègent'
  },
  // protéger - imparfait
  {
    verbInfinitive: 'protéger',
    tense: 'imparfait',
    je: 'protégeais',
    tu: 'protégeais',
    il: 'protégeait',
    nous: 'protégions',
    vous: 'protégiez',
    ils: 'protégeaient'
  },
  // protéger - futur simple
  {
    verbInfinitive: 'protéger',
    tense: 'futur_simple',
    je: 'protégerai',
    tu: 'protégeras',
    il: 'protégera',
    nous: 'protégerons',
    vous: 'protégerez',
    ils: 'protégeront'
  },

  // ranger - present
  {
    verbInfinitive: 'ranger',
    tense: 'present',
    je: 'range',
    tu: 'ranges',
    il: 'range',
    nous: 'rangeons',
    vous: 'rangez',
    ils: 'rangent'
  },
  // ranger - imparfait
  {
    verbInfinitive: 'ranger',
    tense: 'imparfait',
    je: 'rangeais',
    tu: 'rangeais',
    il: 'rangeait',
    nous: 'rangions',
    vous: 'rangiez',
    ils: 'rangeaient'
  },
  // ranger - futur simple
  {
    verbInfinitive: 'ranger',
    tense: 'futur_simple',
    je: 'rangerai',
    tu: 'rangeras',
    il: 'rangera',
    nous: 'rangerons',
    vous: 'rangerez',
    ils: 'rangeront'
  },

  // recevoir - present
  {
    verbInfinitive: 'recevoir',
    tense: 'present',
    je: 'reçois',
    tu: 'reçois',
    il: 'reçoit',
    nous: 'recevons',
    vous: 'recevez',
    ils: 'reçoivent'
  },
  // recevoir - imparfait
  {
    verbInfinitive: 'recevoir',
    tense: 'imparfait',
    je: 'recevais',
    tu: 'recevais',
    il: 'recevait',
    nous: 'recevions',
    vous: 'receviez',
    ils: 'recevaient'
  },
  // recevoir - futur simple
  {
    verbInfinitive: 'recevoir',
    tense: 'futur_simple',
    je: 'recevrai',
    tu: 'recevras',
    il: 'recevra',
    nous: 'recevrons',
    vous: 'recevrez',
    ils: 'recevront'
  },

  // reconnaître - present
  {
    verbInfinitive: 'reconnaître',
    tense: 'present',
    je: 'reconnais',
    tu: 'reconnais',
    il: 'reconnaît',
    nous: 'reconnaissons',
    vous: 'reconnaissez',
    ils: 'reconnaissent'
  },
  // reconnaître - imparfait
  {
    verbInfinitive: 'reconnaître',
    tense: 'imparfait',
    je: 'reconnaissais',
    tu: 'reconnaissais',
    il: 'reconnaissait',
    nous: 'reconnaissions',
    vous: 'reconnaissiez',
    ils: 'reconnaissaient'
  },
  // reconnaître - futur simple
  {
    verbInfinitive: 'reconnaître',
    tense: 'futur_simple',
    je: 'reconnaîtrai',
    tu: 'reconnaîtras',
    il: 'reconnaîtra',
    nous: 'reconnaîtrons',
    vous: 'reconnaîtrez',
    ils: 'reconnaîtront'
  },

  // recueillir - present
  {
    verbInfinitive: 'recueillir',
    tense: 'present',
    je: 'recueille',
    tu: 'recueilles',
    il: 'recueille',
    nous: 'recueillons',
    vous: 'recueillez',
    ils: 'recueillent'
  },
  // recueillir - imparfait
  {
    verbInfinitive: 'recueillir',
    tense: 'imparfait',
    je: 'recueillais',
    tu: 'recueillais',
    il: 'recueillait',
    nous: 'recueillions',
    vous: 'recueilliez',
    ils: 'recueillaient'
  },
  // recueillir - futur simple
  {
    verbInfinitive: 'recueillir',
    tense: 'futur_simple',
    je: 'recueillerai',
    tu: 'recueilleras',
    il: 'recueillera',
    nous: 'recueillerons',
    vous: 'recueillerez',
    ils: 'recueilleront'
  },

  // rejoindre - present
  {
    verbInfinitive: 'rejoindre',
    tense: 'present',
    je: 'rejoins',
    tu: 'rejoins',
    il: 'rejoint',
    nous: 'rejoignons',
    vous: 'rejoignez',
    ils: 'rejoignent'
  },
  // rejoindre - imparfait
  {
    verbInfinitive: 'rejoindre',
    tense: 'imparfait',
    je: 'rejoignais',
    tu: 'rejoignais',
    il: 'rejoignait',
    nous: 'rejoignions',
    vous: 'rejoigniez',
    ils: 'rejoignaient'
  },
  // rejoindre - futur simple
  {
    verbInfinitive: 'rejoindre',
    tense: 'futur_simple',
    je: 'rejoindrai',
    tu: 'rejoindras',
    il: 'rejoindra',
    nous: 'rejoindrons',
    vous: 'rejoindrez',
    ils: 'rejoindront'
  },

  // rendre - present
  {
    verbInfinitive: 'rendre',
    tense: 'present',
    je: 'rends',
    tu: 'rends',
    il: 'rend',
    nous: 'rendons',
    vous: 'rendez',
    ils: 'rendent'
  },
  // rendre - imparfait
  {
    verbInfinitive: 'rendre',
    tense: 'imparfait',
    je: 'rendais',
    tu: 'rendais',
    il: 'rendait',
    nous: 'rendions',
    vous: 'rendiez',
    ils: 'rendaient'
  },
  // rendre - futur simple
  {
    verbInfinitive: 'rendre',
    tense: 'futur_simple',
    je: 'rendrai',
    tu: 'rendras',
    il: 'rendra',
    nous: 'rendrons',
    vous: 'rendrez',
    ils: 'rendront'
  },

  // répéter - present
  {
    verbInfinitive: 'répéter',
    tense: 'present',
    je: 'répète',
    tu: 'répètes',
    il: 'répète',
    nous: 'répétons',
    vous: 'répétez',
    ils: 'répètent'
  },
  // répéter - imparfait
  {
    verbInfinitive: 'répéter',
    tense: 'imparfait',
    je: 'répétais',
    tu: 'répétais',
    il: 'répétait',
    nous: 'répétions',
    vous: 'répétiez',
    ils: 'répétaient'
  },
  // répéter - futur simple
  {
    verbInfinitive: 'répéter',
    tense: 'futur_simple',
    je: 'répéterai',
    tu: 'répéteras',
    il: 'répétera',
    nous: 'répéterons',
    vous: 'répéterez',
    ils: 'répéteront'
  },

  // revenir - present
  {
    verbInfinitive: 'revenir',
    tense: 'present',
    je: 'reviens',
    tu: 'reviens',
    il: 'revient',
    nous: 'revenons',
    vous: 'revenez',
    ils: 'reviennent'
  },
  // revenir - imparfait
  {
    verbInfinitive: 'revenir',
    tense: 'imparfait',
    je: 'revenais',
    tu: 'revenais',
    il: 'revenait',
    nous: 'revenions',
    vous: 'reveniez',
    ils: 'revenaient'
  },
  // revenir - futur simple
  {
    verbInfinitive: 'revenir',
    tense: 'futur_simple',
    je: 'reviendrai',
    tu: 'reviendras',
    il: 'reviendra',
    nous: 'reviendrons',
    vous: 'reviendrez',
    ils: 'reviendront'
  },

  // savoir - present
  {
    verbInfinitive: 'savoir',
    tense: 'present',
    je: 'sais',
    tu: 'sais',
    il: 'sait',
    nous: 'savons',
    vous: 'savez',
    ils: 'savent'
  },
  // savoir - imparfait
  {
    verbInfinitive: 'savoir',
    tense: 'imparfait',
    je: 'savais',
    tu: 'savais',
    il: 'savait',
    nous: 'savions',
    vous: 'saviez',
    ils: 'savaient'
  },
  // savoir - futur simple
  {
    verbInfinitive: 'savoir',
    tense: 'futur_simple',
    je: 'saurai',
    tu: 'sauras',
    il: 'saura',
    nous: 'saurons',
    vous: 'saurez',
    ils: 'sauront'
  },

  // se dépêcher - present
  {
    verbInfinitive: 'se dépêcher',
    tense: 'present',
    je: 'me dépêche',
    tu: 'te dépêches',
    il: 'se dépêche',
    nous: 'nous dépêchons',
    vous: 'vous dépêchez',
    ils: 'se dépêchent'
  },
  // se dépêcher - imparfait
  {
    verbInfinitive: 'se dépêcher',
    tense: 'imparfait',
    je: 'me dépêchais',
    tu: 'te dépêchais',
    il: 'se dépêchait',
    nous: 'nous dépêchions',
    vous: 'vous dépêchiez',
    ils: 'se dépêchaient'
  },
  // se dépêcher - futur simple
  {
    verbInfinitive: 'se dépêcher',
    tense: 'futur_simple',
    je: 'me dépêcherai',
    tu: 'te dépêcheras',
    il: 'se dépêchera',
    nous: 'nous dépêcherons',
    vous: 'vous dépêcherez',
    ils: 'se dépêcheront'
  },

  // se promener - present
  {
    verbInfinitive: 'se promener',
    tense: 'present',
    je: 'me promène',
    tu: 'te promènes',
    il: 'se promène',
    nous: 'nous promenons',
    vous: 'vous promenez',
    ils: 'se promènent'
  },
  // se promener - imparfait
  {
    verbInfinitive: 'se promener',
    tense: 'imparfait',
    je: 'me promenais',
    tu: 'te promenais',
    il: 'se promenait',
    nous: 'nous promenions',
    vous: 'vous promeniez',
    ils: 'se promenaient'
  },
  // se promener - futur simple
  {
    verbInfinitive: 'se promener',
    tense: 'futur_simple',
    je: 'me promènerai',
    tu: 'te promèneras',
    il: 'se promènera',
    nous: 'nous promènerons',
    vous: 'vous promènerez',
    ils: 'se promèneront'
  },

  // se reposer - present
  {
    verbInfinitive: 'se reposer',
    tense: 'present',
    je: 'me repose',
    tu: 'te reposes',
    il: 'se repose',
    nous: 'nous reposons',
    vous: 'vous reposez',
    ils: 'se reposent'
  },
  // se reposer - imparfait
  {
    verbInfinitive: 'se reposer',
    tense: 'imparfait',
    je: 'me reposais',
    tu: 'te reposais',
    il: 'se reposait',
    nous: 'nous reposions',
    vous: 'vous reposiez',
    ils: 'se reposaient'
  },
  // se reposer - futur simple
  {
    verbInfinitive: 'se reposer',
    tense: 'futur_simple',
    je: 'me reposerai',
    tu: 'te reposeras',
    il: 'se reposera',
    nous: 'nous reposerons',
    vous: 'vous reposerez',
    ils: 'se reposeront'
  },

  // se souvenir - present
  {
    verbInfinitive: 'se souvenir',
    tense: 'present',
    je: 'me souviens',
    tu: 'te souviens',
    il: 'se souvient',
    nous: 'nous souvenons',
    vous: 'vous souvenez',
    ils: 'se souviennent'
  },
  // se souvenir - imparfait
  {
    verbInfinitive: 'se souvenir',
    tense: 'imparfait',
    je: 'me souvenais',
    tu: 'te souvenais',
    il: 'se souvenait',
    nous: 'nous souvenions',
    vous: 'vous souveniez',
    ils: 'se souvenaient'
  },
  // se souvenir - futur simple
  {
    verbInfinitive: 'se souvenir',
    tense: 'futur_simple',
    je: 'me souviendrai',
    tu: 'te souviendras',
    il: 'se souviendra',
    nous: 'nous souviendrons',
    vous: 'vous souviendrez',
    ils: 'se souviendront'
  },

  // séduire - present
  {
    verbInfinitive: 'séduire',
    tense: 'present',
    je: 'séduis',
    tu: 'séduis',
    il: 'séduit',
    nous: 'séduisons',
    vous: 'séduisez',
    ils: 'séduisent'
  },
  // séduire - imparfait
  {
    verbInfinitive: 'séduire',
    tense: 'imparfait',
    je: 'séduisais',
    tu: 'séduisais',
    il: 'séduisait',
    nous: 'séduisions',
    vous: 'séduisiez',
    ils: 'séduisaient'
  },
  // séduire - futur simple
  {
    verbInfinitive: 'séduire',
    tense: 'futur_simple',
    je: 'séduirai',
    tu: 'séduiras',
    il: 'séduira',
    nous: 'séduirons',
    vous: 'séduirez',
    ils: 'séduiront'
  },

  // suivre - present
  {
    verbInfinitive: 'suivre',
    tense: 'present',
    je: 'suis',
    tu: 'suis',
    il: 'suit',
    nous: 'suivons',
    vous: 'suivez',
    ils: 'suivent'
  },
  // suivre - imparfait
  {
    verbInfinitive: 'suivre',
    tense: 'imparfait',
    je: 'suivais',
    tu: 'suivais',
    il: 'suivait',
    nous: 'suivions',
    vous: 'suiviez',
    ils: 'suivaient'
  },
  // suivre - futur simple
  {
    verbInfinitive: 'suivre',
    tense: 'futur_simple',
    je: 'suivrai',
    tu: 'suivras',
    il: 'suivra',
    nous: 'suivrons',
    vous: 'suivrez',
    ils: 'suivront'
  },

  // surprendre - present
  {
    verbInfinitive: 'surprendre',
    tense: 'present',
    je: 'surprends',
    tu: 'surprends',
    il: 'surprend',
    nous: 'surprenons',
    vous: 'surprenez',
    ils: 'surprennent'
  },
  // surprendre - imparfait
  {
    verbInfinitive: 'surprendre',
    tense: 'imparfait',
    je: 'surprenais',
    tu: 'surprenais',
    il: 'surprenait',
    nous: 'surprenions',
    vous: 'surpreniez',
    ils: 'surprenaient'
  },
  // surprendre - futur simple
  {
    verbInfinitive: 'surprendre',
    tense: 'futur_simple',
    je: 'surprendrai',
    tu: 'surprendras',
    il: 'surprendra',
    nous: 'surprendrons',
    vous: 'surprendrez',
    ils: 'surprendront'
  },

  // taire - present
  {
    verbInfinitive: 'taire',
    tense: 'present',
    je: 'tais',
    tu: 'tais',
    il: 'tait',
    nous: 'taisons',
    vous: 'taisez',
    ils: 'taisent'
  },
  // taire - imparfait
  {
    verbInfinitive: 'taire',
    tense: 'imparfait',
    je: 'taisais',
    tu: 'taisais',
    il: 'taisait',
    nous: 'taisions',
    vous: 'taisiez',
    ils: 'taisaient'
  },
  // taire - futur simple
  {
    verbInfinitive: 'taire',
    tense: 'futur_simple',
    je: 'tairai',
    tu: 'tairas',
    il: 'taira',
    nous: 'tairons',
    vous: 'tairez',
    ils: 'tairont'
  },

  // tenir - present
  {
    verbInfinitive: 'tenir',
    tense: 'present',
    je: 'tiens',
    tu: 'tiens',
    il: 'tient',
    nous: 'tenons',
    vous: 'tenez',
    ils: 'tiennent'
  },
  // tenir - imparfait
  {
    verbInfinitive: 'tenir',
    tense: 'imparfait',
    je: 'tenais',
    tu: 'tenais',
    il: 'tenait',
    nous: 'tenions',
    vous: 'teniez',
    ils: 'tenaient'
  },
  // tenir - futur simple
  {
    verbInfinitive: 'tenir',
    tense: 'futur_simple',
    je: 'tiendrai',
    tu: 'tiendras',
    il: 'tiendra',
    nous: 'tiendrons',
    vous: 'tiendrez',
    ils: 'tiendront'
  },

  // traduire - present
  {
    verbInfinitive: 'traduire',
    tense: 'present',
    je: 'traduis',
    tu: 'traduis',
    il: 'traduit',
    nous: 'traduisons',
    vous: 'traduisez',
    ils: 'traduisent'
  },
  // traduire - imparfait
  {
    verbInfinitive: 'traduire',
    tense: 'imparfait',
    je: 'traduisais',
    tu: 'traduisais',
    il: 'traduisait',
    nous: 'traduisions',
    vous: 'traduisiez',
    ils: 'traduisaient'
  },
  // traduire - futur simple
  {
    verbInfinitive: 'traduire',
    tense: 'futur_simple',
    je: 'traduirai',
    tu: 'traduiras',
    il: 'traduira',
    nous: 'traduirons',
    vous: 'traduirez',
    ils: 'traduiront'
  },

  // trouver - present
  {
    verbInfinitive: 'trouver',
    tense: 'present',
    je: 'trouve',
    tu: 'trouves',
    il: 'trouve',
    nous: 'trouvons',
    vous: 'trouvez',
    ils: 'trouvent'
  },
  // trouver - imparfait
  {
    verbInfinitive: 'trouver',
    tense: 'imparfait',
    je: 'trouvais',
    tu: 'trouvais',
    il: 'trouvait',
    nous: 'trouvions',
    vous: 'trouviez',
    ils: 'trouvaient'
  },
  // trouver - futur simple
  {
    verbInfinitive: 'trouver',
    tense: 'futur_simple',
    je: 'trouverai',
    tu: 'trouveras',
    il: 'trouvera',
    nous: 'trouverons',
    vous: 'trouverez',
    ils: 'trouveront'
  },

  // venir - present
  {
    verbInfinitive: 'venir',
    tense: 'present',
    je: 'viens',
    tu: 'viens',
    il: 'vient',
    nous: 'venons',
    vous: 'venez',
    ils: 'viennent'
  },
  // venir - imparfait
  {
    verbInfinitive: 'venir',
    tense: 'imparfait',
    je: 'venais',
    tu: 'venais',
    il: 'venait',
    nous: 'venions',
    vous: 'veniez',
    ils: 'venaient'
  },
  // venir - futur simple
  {
    verbInfinitive: 'venir',
    tense: 'futur_simple',
    je: 'viendrai',
    tu: 'viendras',
    il: 'viendra',
    nous: 'viendrons',
    vous: 'viendrez',
    ils: 'viendront'
  },

  // vivre - present
  {
    verbInfinitive: 'vivre',
    tense: 'present',
    je: 'vis',
    tu: 'vis',
    il: 'vit',
    nous: 'vivons',
    vous: 'vivez',
    ils: 'vivent'
  },
  // vivre - imparfait
  {
    verbInfinitive: 'vivre',
    tense: 'imparfait',
    je: 'vivais',
    tu: 'vivais',
    il: 'vivait',
    nous: 'vivions',
    vous: 'viviez',
    ils: 'vivaient'
  },
  // vivre - futur simple
  {
    verbInfinitive: 'vivre',
    tense: 'futur_simple',
    je: 'vivrai',
    tu: 'vivras',
    il: 'vivra',
    nous: 'vivrons',
    vous: 'vivrez',
    ils: 'vivront'
  },

  // voir - present
  {
    verbInfinitive: 'voir',
    tense: 'present',
    je: 'vois',
    tu: 'vois',
    il: 'voit',
    nous: 'voyons',
    vous: 'voyez',
    ils: 'voient'
  },
  // voir - imparfait
  {
    verbInfinitive: 'voir',
    tense: 'imparfait',
    je: 'voyais',
    tu: 'voyais',
    il: 'voyait',
    nous: 'voyions',
    vous: 'voyiez',
    ils: 'voyaient'
  },
  // voir - futur simple
  {
    verbInfinitive: 'voir',
    tense: 'futur_simple',
    je: 'verrai',
    tu: 'verras',
    il: 'verra',
    nous: 'verrons',
    vous: 'verrez',
    ils: 'verront'
  },
];
